import React, { useState, useEffect } from "react";
import ContainerHeader from "components/ContainerHeader";
import DeliveryAddress from "./DeliveryAddress";
import { connect } from "react-redux";
import { getUserDetail } from "actions";
import { getCartDetails } from "actions/buyer";
import { getMediWallet } from "actions/buyer";
import { removeFromCart, emptyCart } from "actions/buyer";
import { addToCart } from "actions/buyer";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import MyCartModalError from "./MyCartModalError";
import ClaimVouchersModal from "./ClaimVouchersModal";
import { scatterConfetti, originFromEvent } from "util/confetti";
import { liquidSurchargeRate, liquidSurchargeForLine } from "util/liquidSurcharge";
import { FormGroup, Col, Row, Label, Input } from "reactstrap";
import Radio from "@mui/material/Radio";
import Tooltip from "@mui/material/Tooltip";
import { NotificationManager } from "react-notifications";
import { NavLink, useNavigate } from "react-router-dom";
import AxiosRequest from "sagas/axiosRequest";
import CartItems from "./CartItems";
import axios from "axios";
import AppConfig from "constants/config";
import moment from "moment";
import "./index.css";
import BuyerContainer from "components/buyerContainer";

const borderEthical = {
  border: "2px solid #ff7000",
  borderRadius: "8px",
  padding: "5px",
  c: "#ff7000",
};
const borderCoolChain = {
  border: "2px solid #0b68a8",
  borderRadius: "8px",
  padding: "5px",
  c: "#0b68a8",
};
const borderGeneric = {
  border: "2px solid  #038d0e",
  borderRadius: "8px",
  padding: "5px",
  c: "#038d0e",
};
const fontS = {
  fontWeight: "bolder",
  marginTop: "5px",
};

/*
When a cashback reaches the buyer - said ONCE, on a card of its own under the Medimny offer banner
(cashbackWalletNoteCard).

It is not repeated in the three summary tables. Those now carry the cashback figures BELOW the amount
due rather than among the rows that add up to it, which is what stops them reading as money off this
payment; a sentence under each of them as well was three copies of one fact, and none of the three
could speak for both tiers at once the way the card does.

The platform banner's own "credited once delivered" line is gone for the same reason - one statement,
one place, covering the seller's cashback and Medimny's alike.
*/
const CASHBACK_WALLET_NOTE =
  "The cashback amount will be added to your MediWallet after the order is delivered.";

const MyCart = (props) => {
  const navigate = useNavigate();
  // The gift whose picture is open over the cart, or null. Holds the campaign's own gift object, so
  // one dialog serves every banner on the page: the seller's, Medimny's, and the card at the top.
  const [giftView, setGiftView] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [errorData, setErrorData] = useState([]);
  const [acceptModal, setAcceptModal] = useState(false);
  const [successData, setSuccessData] = useState([]);
  /*
  Claiming is a UI affordance, and nothing more. The buyer gets every voucher their cart qualifies
  for when the order is placed, whether or not they ever pressed Claim - the API applies them
  unconditionally and stores no claim flag. The button exists because being handed a discount reads
  as an accident, while claiming one reads as a win; it does not gate a single rupee.

  So all claim state lives here, in the component, and is deliberately NOT persisted: a reload puts
  the buyer back to unclaimed and they claim again, which costs them nothing.
  */
  // The voucher rows the buyer has pressed Claim on, by row key - what makes a row read "Claimed"
  // in the modal.
  const [claimedVoucherKeys, setClaimedVoucherKeys] = useState([]);
  /*
  What has been claimed, by CHECKOUT BLOCK - `sellerId|block`, the same key blockSavings uses.

  A block, not a seller, because a block is what becomes one order: cool chain ships on its own and
  everything else together, so one seller can have two. Checking out a seller's cool-chain block
  buys nothing from their other block, so it must not claim that block's vouchers either - those
  stay on offer until the buyer checks that block out or claims it from the modal.

  A seller-wide claim (the Applicable Vouchers modal, Seller CheckOut) simply marks every block that
  seller has.
  */
  const [claimedBlocks, setClaimedBlocks] = useState([]);
  const blockKey = (sellerUserId, block) => `${sellerUserId}|${block}`;
  const isBlockClaimed = (sellerUserId, block) =>
    sellerUserId != null &&
    claimedBlocks.indexOf(blockKey(sellerUserId, block)) > -1;
  // True only when EVERY block this seller has a reward in has been claimed - what the seller-wide
  // checkout card asks, since it prices the seller's whole cart.
  //
  // A reward, not a voucher row: a seller whose only campaign is a cashback has no rows in the modal
  // at all, and reading rows alone left them permanently unclaimed - their card would never reveal
  // the cashback however many times the buyer checked out.
  const isSellerClaimed = (sellerUserId) => {
    if (sellerUserId == null) return false;
    const groups = voucherGroups.filter(
      (group) => String(group.sellerId) === String(sellerUserId),
    );
    const blocks = groups.reduce(
      (acc, group) =>
        group.rows.reduce(
          (a, row) => (a.indexOf(row.block) > -1 ? a : [...a, row.block]),
          acc,
        ),
      valueTierKeysInScope(sellerUserId).map((key) => key.split("|")[1]),
    );
    return (
      blocks.length > 0 &&
      blocks.every((block) => isBlockClaimed(sellerUserId, block))
    );
  };
  const markBlocksClaimed = (keys) => {
    if (!keys || keys.length < 1) return;
    setClaimedBlocks((prev) => Array.from(new Set([...(prev || []), ...keys])));
  };
  // The checkout block whose Applicable Vouchers modal is open, as a `sellerId|block` key (or null
  // when closed). Each order-type block (Cool chain / the rest) opens its own modal, scoped to that
  // block's product coupons/gifts plus its Medimny and seller value-tier offers.
  const [voucherModalKey, setVoucherModalKey] = useState(null);
  // What the vouchers were worth at the moment the order was placed - the cart empties immediately
  // after, so the success modal cannot recompute it and has to be handed a snapshot.
  const [orderSavings, setOrderSavings] = useState(null);
  const [minOrderError, setMinOrderError] = useState(false);
  const [open, setOpen] = useState(false);
  const [globalCod, setGlobalCod] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [individualPop, setIndividualPop] = useState(false);
  const [individualSeller, setIndividualSeller] = useState("");
  const [medicinePop, setMedicinePop] = useState(false);
  const [mediTypeData, setMediTypeData] = useState("");
  const [mediData, setMediData] = useState("");
  const [ethicalData, setEthicalData] = useState("");
  const [coolChainData, setCoolChainData] = useState("");
  const [genericData, setGenericData] = useState("");
  const [deliChrg, setDeliChrg] = useState(0);
  const [globalDeliveryCrg, setGlobalDeliveryCrg] = useState("");
  const [newGlobalDeliveryCrg, setNewGlobalDeliveryCrg] = useState(0);
  const [globalBnpl, setGlobalBnpl] = useState("");
  const [otpModel, setOtpModel] = useState(false);
  const [otp, setOtp] = useState("");
  const [set, setSet] = useState(false);
  const [otpId, setOtpId] = useState("");
  const [bnplBal, setBnplBal] = useState("");
  const [openNewPopup, setOpenNewPopup] = useState(false);
  const [LicenseErr, setLicenseErr] = useState(false);
  const [totalDeliverd, setTotalDeliverd] = useState(0);
  const [totalOpenCOD, setTotalOpenCOD] = useState(0);
  const [codTotalAmount, setCodTotalAmount] = useState(0);
  const [minOrderErrorIndividual, setMinOrderErrorIndividual] = useState(false);
  const [checkOutVal, setChekOutVal] = useState();
  const [prodcheckOutVal, setProdChekOutVal] = useState();
  const [PrpaymentCod, setPrpaymentCod] = useState();
  const [mediprepayment, setMediprepayment] = useState(0);
  const [deliveryMinRange, setDeliveryMinRange] = useState();
  const [deliveryMaxRange, setDeliveryMaxRange] = useState();
  const [individualCharges, setIndividualCharges] = useState(0);
  const [showCodOption, setShowCodOption] = useState(true);
  const [showUpiToggle, setShowUpiToggle] = useState(false);
  const [upiType, setUpiType] = useState("");

  const asAdmin = localStorage.getItem("asAdmin");

  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
    setUpiType("");
    if (event.target.value != "COD") {
      setShowUpiToggle(true);
    } else {
      setShowUpiToggle(false);
      setUpiType("");
    }
  };

  const upiRadioChange = (event) => {
    setUpiType(event.target.value);
  };

  const getInitialData = async () => {
    try {
      const isUserLoggedIn = localStorage.getItem("buyer_token");
      if (isUserLoggedIn !== null) {
        let data = {
          page: 1,
          perPage: 10,
          filter: "",
          month: "",
          year: "",
        };
        props.getMediWallet({ data });
        props.getCartDetails({});
      } else {
      }

      const result = await axios({
        method: "get",
        url: `${AppConfig.baseUrl}users/getCodService`,
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("buyer_token"),
        },
      });
      setTotalDeliverd(
        Number(
          result && result.data && result.data.totalDeliverd
            ? result.data.totalDeliverd
            : 0,
        ),
      );
      setTotalOpenCOD(
        Number(
          result && result.data && result.data.totalOpenCOD
            ? result.data.totalOpenCOD
            : 0,
        ),
      );
      setCodTotalAmount(
        Number(
          result && result.data && result.data.codTotalAmount
            ? result.data.codTotalAmount
            : 0,
        ),
      );

      const configResult = await axios({
        method: "post",
        url: `${AppConfig.baseUrl}systemConfig/getAllSystemConfigList`,
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("buyer_token"),
        },
      });
      if (
        configResult.data &&
        configResult.data.detail &&
        !configResult.data.error
      ) {
        configResult.data.detail.map((data) => {
          if (data.key === "globalCod") {
            setGlobalCod(data);
          }
          if (data.key === "globalBnpl") {
            setGlobalBnpl(data);
          }
          if (data.key === "delivery_charge") {
            setGlobalDeliveryCrg(data);
          }
          if (data.key === "new_delivery_charge") {
            setNewGlobalDeliveryCrg(data);
          }
          if (data.key === "delivery_min_range") {
            setDeliveryMinRange(data);
          }
          if (data.key === "delivery_max_range") {
            setDeliveryMaxRange(data);
          }
        });
      }
      const catResult = await axios({
        method: "get",
        url: `${AppConfig.baseUrl}medicine/listMediCategory`,
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("buyer_token"),
        },
      });
      if (catResult.data && catResult.data.data && !catResult.data.error) {
        catResult.data.data.map(async (data) => {
          if (data.name === "Ethical branded") {
            setEthicalData(data);
          }
          if (data.name === "Cool chain") {
            setCoolChainData(data);
          }
          if (data.name === "Generic") {
            setGenericData(data);
          }
        });
        setMediData(catResult.data.data);
      }
      const bnplResult = await axios({
        method: "post",
        url: `${AppConfig.baseUrl}bnpl/getBnplBal`,
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("buyer_token"),
        },
      });
      if (bnplResult.data && bnplResult.data.data && !bnplResult.data.error) {
        setBnplBal(bnplResult.data.data.availableLimit);
      }
    } catch (error) {}
  };

  let disableCOD = false;
  useEffect(() => {
    getInitialData();
    setShowCodOption(true);
    sellerDetails.map((data, index) => {
      if (users.isDeliveryCharge === true) {
        deliveryTotal.push(Number(globalDeliveryCrg?.value));
      }
      if (
        data.ethical &&
        data.ethical > 0 &&
        deliveryMinRange?.value <= data.ethical &&
        data.ethical < deliveryMaxRange?.value
      ) {
        totalDeliChrgInCart =
          totalDeliChrgInCart + Number(newGlobalDeliveryCrg?.value);
        disableCOD = true;
      }
      if (
        data.coolChain &&
        data.coolChain > 0 &&
        deliveryMinRange?.value <= data.coolChain &&
        data.coolChain < deliveryMaxRange?.value
      ) {
        totalDeliChrgInCart =
          totalDeliChrgInCart + Number(newGlobalDeliveryCrg?.value);
        disableCOD = true;
      }
      if (users.isDeliveryCharge === true) {
        if (
          data.ethical &&
          data.ethical > 0 &&
          !(
            deliveryMinRange?.value <= data.ethical &&
            data.ethical < deliveryMaxRange?.value
          )
        ) {
          totalDeliChrgInCart =
            totalDeliChrgInCart + Number(globalDeliveryCrg.value);
        }
        if (
          data.coolChain &&
          data.coolChain > 0 &&
          !(
            deliveryMinRange?.value <= data.coolChain &&
            data.coolChain < deliveryMaxRange?.value
          )
        ) {
          totalDeliChrgInCart =
            totalDeliChrgInCart + Number(globalDeliveryCrg.value);
        }
      }
    });
    if (disableCOD) {
      setShowCodOption(false);
    } else {
      setShowCodOption(true);
    }
  }, []);

  // Voucher details (coupons, cashback, gift, MOV hints) and the discounted payable are shown
  // directly in the MyCart summary below for every tier the cart qualifies for, whether or not the
  // buyer has pressed Claim. The summary reads from `tierSavings` (computed each render from the
  // campaign data on the cart), and placement grants exactly the same set - so the numbers shown
  // here are what the buyer gets either way.

  /*
  The whole celebration, in one place: confetti out of the pressed button and the "We Found a better
  deal for you" toast, together. They are two halves of one message - the confetti catches the eye,
  the toast says what just happened - so nothing may fire one without the other.

  ONE PRESS, ONE CELEBRATION. It used to fire once per thing won - per seller on the cart-wide
  confirm, per order-type block on a Seller CheckOut - which meant a seller stocking both a cool-chain
  and an ordinary block scattered twice and stacked two identical toasts, and the cart-wide confirm
  did it once per seller. Repeating the same sentence does not make the news bigger; it reads as a
  glitch. What the buyer won is spelled out in the summary either way, so this says it once and lets
  the summary carry the detail.

  Every caller has already established that these claims win the buyer something they did not have a
  moment ago; that check is the gate, not anything in here.
  */
  const celebrateClaim = (event) => {
    scatterConfetti(originFromEvent(event));
    NotificationManager.success("We Found a better deal for you");
  };

  // Each checkout block's "Applicable Vouchers" button (top-right of that seller's checkout card)
  // opens the modal scoped to that block - it no longer claims anything. The buyer claims from inside
  // the modal with its single "Claim All" button, which calls claimAllVouchers. The `sellerId|block`
  // key is held in voucherModalKey so the modal shows only that block's offers.
  const openVouchersModal = (sellerUserId, block) =>
    setVoucherModalKey(blockKey(sellerUserId, block));

  /*
  The voucher rows this cart is already clearing the minimum on - exactly the set checkout applies -
  narrowed to whatever the buyer just acted on. Read from the render-scoped `voucherGroups` below,
  which is filled before any of these handlers can fire.

    applicableRows()                -> the whole cart
    applicableRows(sellerId)        -> that seller, both their blocks
    applicableRows(sellerId, block) -> ONE checkout block of that seller

  The third form is what an order-type checkout uses: a buyer paying for a seller's cool-chain order
  claims that order's vouchers and nothing else, leaving the same seller's other block on offer.
  */
  const applicableRows = (sellerUserId, block) =>
    voucherGroups
      .filter(
        (group) =>
          sellerUserId == null ||
          String(group.sellerId) === String(sellerUserId),
      )
      .reduce((rows, group) => rows.concat(group.rows), [])
      .filter((row) => row.applied && (block == null || row.block === block));

  const applicableVoucherKeys = (sellerUserId, block) =>
    applicableRows(sellerUserId, block).map((row) => row.key);

  // The value-tier blocks (see valueTierBlockKeys) inside one claim's scope, narrowed the same way
  // the product rows are: a seller-wide claim takes both of that seller's blocks, an order-type
  // claim only the block being paid for, a cart-wide one the lot.
  const valueTierKeysInScope = (sellerUserId, block) =>
    valueTierBlockKeys.filter((key) => {
      const [uid, blk] = key.split("|");
      return (
        (sellerUserId == null || String(uid) === String(sellerUserId)) &&
        (block == null || blk === block)
      );
    });

  // The `sellerId|block` keys covered by one claim. A block-scoped claim is one key; a seller-wide
  // or cart-wide one covers every block those rewards sit in.
  //
  // BOTH kinds of reward make a block claimable: the product coupons/gifts listed in the modal, and
  // the value-tier cashbacks and store-wide gifts that are attached automatically. A seller running
  // only a cashback has no rows here, and used to check out with nothing claimed and nothing said.
  const claimedBlockKeys = (sellerUserId, block) =>
    Array.from(
      new Set(
        voucherGroups
          .filter(
            (group) =>
              sellerUserId == null ||
              String(group.sellerId) === String(sellerUserId),
          )
          .reduce(
            (keys, group) =>
              keys.concat(
                group.rows
                  // `applied` as well as the block: a voucher still locked below its minimum is not
                  // claimable, so a block holding nothing but locked rows is not claimed and not
                  // celebrated. Product rows never lock today - this keeps step with the modal,
                  // which explains locked rows rather than claiming them.
                  .filter(
                    (row) =>
                      row.applied && (block == null || row.block === block),
                  )
                  .map((row) => blockKey(group.sellerId, row.block)),
              ),
            [],
          )
          .concat(valueTierKeysInScope(sellerUserId, block)),
      ),
    );

  /*
  The buyer pressed "Claim All" in the modal - which is to say, they pressed the button that makes
  the vouchers theirs. Nothing leaves the browser: it marks that seller's applicable rows claimed so
  the modal reads "Claimed" and the seller's card reveals the full savings from here on. Placement
  grants the very same vouchers to a buyer who never opens this modal.

  Only the seller whose modal is open is marked. Every other seller's card keeps offering its own
  Claim until the buyer opens that seller's modal and presses it.

  Vouchers that have not cleared their minimum order value cannot be claimed; the modal reveals the
  exact shortfall under each of those rows and leaves them unclaimed.
  */
  const claimAllVouchers = (event) => {
    // Block-scoped: the modal lists one checkout block's vouchers, so pressing Claim All claims that
    // block only. MERGED into claimedVoucherKeys, not replacing it - claiming one block must not wipe
    // the "Claimed" state already shown for another block or seller.
    if (!voucherModalKey) return;
    const [sellerUserId, block] = voucherModalKey.split("|");
    const applicable = applicableVoucherKeys(sellerUserId, block);
    // Counted BEFORE the state below is touched, exactly as the checkout path does: the blocks this
    // press claims that were not claimed a moment ago. A block with no product rows at all - a
    // seller running nothing but a cashback, or a Medimny-funded tier on its own - wins something
    // real here, and reading `applicable` alone left that press silent.
    const winners = claimedBlockKeys(sellerUserId, block).filter(
      (key) => claimedBlocks.indexOf(key) === -1,
    );
    setClaimedVoucherKeys((prev) =>
      Array.from(new Set([...(prev || []), ...applicable])),
    );
    markBlocksClaimed(claimedBlockKeys(sellerUserId, block));
    // The press that wins something is the press that gets celebrated. Nothing to win - every
    // campaign locked below its minimum, or all of them already claimed - and it stays quiet, so the
    // confetti never contradicts the shortfall messages the modal is about to show.
    if (applicable.length > 0 || winners.length > 0) celebrateClaim(event);
  };

  /*
  A buyer who skips the Claim button and heads straight to a checkout button (Seller CheckOut,
  CheckOut, Confirm Your Order, ...) is getting every applicable voucher anyway, so this marks them
  claimed on the way through and celebrates it exactly as the Claim button would. The order is
  priced identically either way - this only stops the checkout from staying silent about a discount
  the buyer is about to receive.

  Scope it to exactly what the buyer is paying for:

    (null)             cart-wide "Confirm Your Order" -> every seller, every block
    (sellerId)         "Seller CheckOut"              -> that seller, both their blocks
    (sellerId, block)  an order-type CheckOut         -> that ONE block

  The last is the tightest and the one that matters most: paying for a seller's cool-chain order
  claims that order's vouchers only. The same seller's other order type is untouched and keeps
  offering its own Claim until the buyer checks IT out or claims it from the modal.
  */
  const autoApplyVouchersAtCheckout = (sellerUserId, event, block) => {
    const applicable = applicableVoucherKeys(sellerUserId, block);
    // The blocks this one click wins something NEW from - a voucher the buyer did not already hold
    // a moment ago. A block already claimed is not celebrated twice.
    //
    // Counted BEFORE the state below is touched, since that is exactly what changes the answer.
    const winners = claimedBlockKeys(sellerUserId, block).filter(
      (key) => claimedBlocks.indexOf(key) === -1,
    );
    setClaimedVoucherKeys((prev) =>
      Array.from(new Set([...(prev || []), ...applicable])),
    );
    markBlocksClaimed(claimedBlockKeys(sellerUserId, block));
    // `winners` decides WHETHER to celebrate, never how many times: a Seller CheckOut on a seller
    // with a cool-chain block and an ordinary one wins two blocks in a single press, and that is one
    // piece of good news, not two. Same for the cart-wide confirm across five sellers.
    if (winners.length > 0) celebrateClaim(event);
  };

  /*
  Run immediately before every order is placed. Snapshots what the vouchers are worth for the
  post-order success modal - the cart is emptied right after, so it cannot be recomputed there.

  Nothing is "ensured" server-side: placement applies every eligible voucher on its own, so there is
  no claim to commit first and no path that can reach placement under-discounted.
  */
  const snapshotOrderSavings = () => {
    // "You saved" (immediate) = ONLY the product coupons - the only discount off THIS payable. BOTH
    // cashbacks (seller + platform) are credited to the buyer's MediWallet on delivery, so they are
    // carried separately and shown as "on delivery" lines in the success modal.
    setOrderSavings(
      hasAnyReward()
        ? {
            total: Number(tierSavings.coupons.toFixed(2)),
            coupons: tierSavings.coupons,
            cashback: tierSavings.cashback,
            platform: tierSavings.platform,
            // Carried so the success modal can confirm the gift is coming. A gift-only order has
            // every rupee figure at 0, so without this the modal had nothing to show and said
            // nothing at all - on the one order where the gift IS the whole reward.
            gifts: tierSavings.gifts,
          }
        : null,
    );
  };

  const handleChanged = (e) => {
    setOtp(e.target.value);
  };

  const getMediTypeAmount = (mediTypeData = {}) => {
    const { key } = mediTypeData;

    switch (key) {
      case "Cool chain":
        return (
          Number(mediTypeData.coolChain || 0) +
          Number(mediTypeData.coolChainGst || 0)
        );

      case "Ethical branded":
        return (
          Number(mediTypeData.ethical || 0) +
          Number(mediTypeData.ethicalGst || 0)
        );

      case "Generic":
        return (
          Number(mediTypeData.generic || 0) +
          Number(mediTypeData.genericGst || 0)
        );

      default:
        return 0;
    }
  };

  const handleRemoveFromCart = (index) => {
    const isUserLoggedInn = localStorage.getItem("buyer_token");
    if (isUserLoggedInn !== null) {
      props.removeFromCart({ inventory_id: index });
    } else {
    }
  };

  const handleMedicineOrder = async () => {
    setIsLoading(true);
    snapshotOrderSavings();
    let data = {
      type: selectedValue,
      seller: mediTypeData ? mediTypeData.ID : "",
      medicineId: mediTypeData ? mediTypeData.medicineId : "",
      ordered_from: "web",
    };
    let bulkInven = props.cartDetails.detail.filter(
      (e) =>
        e.Inventory.isBulk === true &&
        mediTypeData.medicineId === e.Inventory.medicineType_id &&
        mediTypeData.ID === e.Inventory.user_id,
    );
    let isBulk = bulkInven.length > 0 ? "bulk" : "";
    let result = await AxiosRequest.axiosBuyerHelperFunc(
      "post",
      "order/createOrder",
      "",
      data,
    );
    if (result?.data?.error) {
      if (result.data && result.data.data) {
        setOpenModal(true);
        setErrorData(result.data.data);
        result.data?.data &&
          result.data.data.map((val) => {
            if (val.productName && val.productName === "License Related") {
              setLicenseErr(true);
            }
          });
        setIsLoading(false);
      } else {
        setIsLoading(false);
        NotificationManager.error(result.data.title);
        handleOnlineModalClose();
      }
    } else {
      if (result.data.token) {
        window.location.assign(
          `${AppConfig.baseUrl}payOnline/${
            result.data.token
          }?type=${isBulk}&upiType=${upiType === "upi" ? "upi" : ""}`,
        );
      } else {
        NotificationManager.success(result.data.title);
        props.getUserDetail({ userType: "buyer" });
        let orderIds = result.data.detail
          .map((data) => {
            return data.order_id;
          })
          .join(", ");
        setAcceptModal(true);
        setSuccessData(orderIds);
        setIndividualSeller("");
        setIsLoading(false);
        setIndividualPop(false);
        setMedicinePop(false);
        setDeliChrg(0);
        setOpenNewPopup(false);
      }
    }
  };

  const handleOnlineOrder = async () => {
    setIsLoading(true);
    snapshotOrderSavings();
    let data = {
      type: selectedValue,
      seller: individualSeller && individualSeller.ID,
      ordered_from: "web",
    };
    let bulkInven = [];
    let isBulk = "";
    if (individualSeller && individualSeller.ID) {
      bulkInven = props.cartDetails.detail.filter(
        (e) =>
          e.Inventory.isBulk === true &&
          individualSeller.ID === e.Inventory.user_id,
      );
    } else {
      bulkInven = props.cartDetails.detail.filter(
        (e) => e.Inventory.isBulk === true,
      );
    }
    isBulk = bulkInven.length > 0 ? "bulk" : "";
    if (selectedValue === "BNPL") {
      data.otpId = otpId;
      data.otp = otp;
    }
    let result = await AxiosRequest.axiosBuyerHelperFunc(
      "post",
      "order/createOrder",
      "",
      data,
    );
    if (result.data.error) {
      if (!result.data.bnpl) {
        if (!result.data.data) {
          NotificationManager.error(result.data.title);
        } else {
          setOpenModal(true);
          setErrorData(result.data.data);
        }
      } else {
        NotificationManager.error(result.data.title);
        handleOnlineModalClose();
      }
      setIsLoading(false);
    } else {
      if (result.data.token) {
        window.location.assign(
          `${AppConfig.baseUrl}payOnline/${
            result.data.token
          }?type=${isBulk}&upiType=${upiType === "upi" ? "upi" : ""}`,
        );
      } else {
        NotificationManager.success(result.data.title);
        props.getUserDetail({ userType: "buyer" });
        let orderIds = result.data.detail
          .map((data) => {
            return data.order_id;
          })
          .join(", ");
        setAcceptModal(true);
        setSuccessData(orderIds);
        setIndividualSeller("");
        setIsLoading(false);
        setIndividualPop(false);
        setDeliChrg(0);
        setOpenNewPopup(false);
      }
    }
    handleCloseOtpModel();
    handleOnlineModalClose();
  };

  /*
  Reached from two places: the cart-wide "Confirm Your Order" in the Order Summary, and the COD
  "Order" button inside a single seller's / medicine block's checkout dialog. Which one it is
  decides how much gets claimed - and so whether there is anything left to throw confetti for.

  A buyer who never opened a seller-specific checkout and never pressed Claim All arrives here with
  nothing claimed, so the cart-wide branch claims every seller at once and the confetti fires for
  the lot. A buyer who came through a seller's dialog already claimed that seller on the way in, so
  scoping to them leaves the rest of the cart alone and no second burst fires.
  */
  /*
  Every checkout confirm button funnels through here, whichever payment method the buyer picked
  (COD, Partial, Online, BNPL), so the vouchers are claimed - and celebrated - exactly once and on
  every route to an order. Before this the Online and BNPL buttons bypassed the voucher path
  completely, so those buyers reached placement with nothing marked claimed.

  What gets claimed depends on which checkout is open, and that in turn decides whether there is
  anything left to throw confetti for:

  - an order-type dialog -> that seller's ONE block, matching the CheckOut that opened it.
  - a seller's checkout dialog -> that seller, both blocks.
  - neither open, i.e. the cart-wide "Confirm Your Order" in the Order Summary -> every seller at
    once. A buyer who never opened a seller checkout and never pressed Claim All arrives with
    nothing claimed, and gets the burst for the whole cart right here.

  In the first two cases the scope was already claimed on the way into the dialog, so no second
  burst fires here - the re-claim is a no-op that exists so the Online and BNPL routes cannot slip
  past unclaimed.
  */
  const claimForOpenCheckout = (event) => {
    if (medicinePop) {
      // Same derivation the block's own summary uses further down: mediTypeData.key is the medicine
      // type this dialog is checking out, and only cool chain ships as its own order.
      autoApplyVouchersAtCheckout(
        mediTypeData && mediTypeData.ID,
        event,
        mediTypeData && mediTypeData.key === "Cool chain" ? "cool" : "other",
      );
      return;
    }
    autoApplyVouchersAtCheckout(
      individualPop ? individualSeller && individualSeller.ID : null,
      event,
    );
  };

  const handleOnlineModal = async (event) => {
    claimForOpenCheckout(event);
    setOpen(true);
  };

  const handleOnlineModalClose = async () => {
    setShowUpiToggle(false);
    setOpen(false);
    setIndividualPop(false);
    setDeliChrg(0);
    setSelectedValue("");
    setIndividualSeller("");
    setMedicinePop(false);
    setOpenNewPopup(false);
  };

  const handleOpenModal = async () => {
    setIsLoading(true);
    snapshotOrderSavings();
    let data = { type: selectedValue, ordered_from: "web" };
    let bulkInven = props.cartDetails.detail.filter(
      (e) => e.Inventory.isBulk === true,
    );
    let isBulk = bulkInven.length > 0 ? "bulk" : "";
    let result = await AxiosRequest.axiosBuyerHelperFunc(
      "post",
      "order/createOrder",
      "",
      data,
    );
    if (result.data.error) {
      if (result.data?.data) {
        setOpenModal(true);
        setErrorData(result.data.data);
        setIsLoading(false);
      } else {
        NotificationManager.error(result.data.title);
        handleOnlineModalClose();
      }
    } else {
      if (result.data.token) {
        window.location.assign(
          `${AppConfig.baseUrl}payOnline/${
            result.data.token
          }?type=${isBulk}&upiType=${upiType === "upi" ? "upi" : ""}`,
        );
      } else {
        NotificationManager.success(result.data.title);
        let orderIds1 = result.data.detail
          .map((data) => {
            return data.order_id;
          })
          .join(", ");
        setAcceptModal(true);
        setSuccessData(orderIds1);
        setIndividualSeller("");
        setIsLoading(false);
        setIndividualPop(false);
        setDeliChrg(0);
        setOpenNewPopup(false);
      }
    }
  };

  const handleClose = () => {
    setOpenModal(!openModal);
    setOpen(false);
    setIndividualPop(false);
    setDeliChrg(0);
    setIndividualSeller("");
    setMedicinePop(false);
  };

  const yesShowCart = async () => {
    errorData.map((dataOne) => {
      if (dataOne.type === "update") {
        let data = {
          cart_details: [
            {
              inventory_id: dataOne.inventory_id,
              quantity: dataOne.quantity,
            },
          ],
        };
        props.addToCart({ data });
      }
    });
    let removeArr = [];
    if (removeArr.length > 0) {
      const result = await axios({
        method: "post",
        url: `${AppConfig.baseUrl}cart/removeAll`,
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("buyer_token"),
        },
        data: { inventory: removeArr },
      });
      if (result.data.error) {
      } else {
        props.getCartDetails({});
      }
    }
    handleClose();
  };

  const handleCloseOtpModel = () => {
    setShowUpiToggle(false);
    setOtpModel(false);
    setOtp("");
    setOtpId("");
    setIsLoading(false);
    setSet(false);
  };

  const handleAcceptClose = () => {
    setAcceptModal(false);
    navigate("/", { state: "/MyCart" });
  };

  const handleMinOrderErrorClose = () => {
    setMinOrderError(false);
    setMinOrderErrorIndividual(false);
    setIsLoading(false);
  };

  const minOrderErrorProceed = async () => {
    handleOpenModal();
    setMinOrderError(false);
  };

  const individualCheckout = async (data, event) => {
    // Mark this seller's vouchers claimed (and flash the "better deal" toast + confetti) as the
    // buyer heads to checkout without having pressed Claim - they are getting them regardless.
    // Scoped to this seller: they are paying for this block only, so no other seller's card is
    // claimed, and a seller with no voucher on any of their products gets no confetti.
    autoApplyVouchersAtCheckout(data && data.ID, event);
    let inventoryFor = [];
    let { cartDetails, users } = props;
    let range_multiplier = 0;
    let userCharge_multiplier = 0;
    setShowCodOption(true);
    let isUserDeliveryCharge = users && users.isDeliveryCharge === true;
    if (
      data.coolChain > 0 &&
      deliveryMinRange?.value <= data.coolChain &&
      data.coolChain < deliveryMaxRange?.value
    ) {
      range_multiplier = range_multiplier + 1; //0
    }
    if (
      data.ethical > 0 &&
      deliveryMinRange?.value <= data.ethical &&
      data.ethical < deliveryMaxRange?.value
    ) {
      range_multiplier = range_multiplier + 1; //0
    }

    if (isUserDeliveryCharge) {
      if (
        data.coolChain > 0 &&
        data.coolChain >= coolChainData.minOrder &&
        !(
          deliveryMinRange?.value <= data.coolChain &&
          data.coolChain < deliveryMaxRange?.value
        )
      ) {
        userCharge_multiplier = userCharge_multiplier + 1; //2
      }
      if (
        data.ethical > 0 &&
        data.ethical >= ethicalData.minOrder &&
        !(
          deliveryMinRange?.value <= data.ethical &&
          data.ethical < deliveryMaxRange?.value
        )
      ) {
        userCharge_multiplier = userCharge_multiplier + 1; //2
      }

      // if (data.generic > 0 && data.generic > genericData.minOrder && !(deliveryMinRange?.value <= data.generic && data.generic < deliveryMaxRange?.value)) {
      //   totalForDeli = totalForDeli + 1;
      // }
    }
    if (range_multiplier > 0) {
      setShowCodOption(false);
    } else {
      setShowCodOption(true);
    }
    // let newdelichrg = newGlobalDeliveryCrg ? Number(newGlobalDeliveryCrg?.value) : 0;
    let delichrg =
      userCharge_multiplier * Number(globalDeliveryCrg.value) +
      range_multiplier * Number(newGlobalDeliveryCrg?.value);
    cartDetails &&
      cartDetails.detail &&
      cartDetails.detail.length > 0 &&
      cartDetails.detail.map((dataOne, index) => {
        if (data.ID === dataOne.Seller._id) {
          inventoryFor.push(([index] = dataOne.Inventory._id));
        }
      });
    let bnplOption = false;
    let cool = true;
    let ethic = true;
    let gene = true;
    if (data.coolChain > 0 && data.coolChain < 5000) {
      cool = false;
    }
    if (data.ethical > 0 && data.ethical < 5000) {
      ethic = false;
    }
    if (data.generic > 0 && data.generic < 5000) {
      gene = false;
    }
    if (cool && ethic && gene) {
      bnplOption = true;
    } else {
      bnplOption = false;
    }
    let data1 = { ...data, bnplOption: bnplOption };
    setDeliChrg(delichrg);
    setIndividualPop(true);
    setIndividualSeller(data1);
    const calVal = Math.max(
      0,
      (data1.price || 0) +
        (data1.gst || 0) +
        Number(delichrg || 0) +
        Number(data1.liquidSurcharge || 0) -
        Number((sellerSavings[String(data1.ID)] || {}).coupons || 0),
    );
    console.log("ddddddddddddd1456", calVal);
    setChekOutVal(calVal);
    const val = data1.PrpaymentCod < 500 ? 500 : data1.PrpaymentCod || 0;
    setPrpaymentCod(val);
    // (((individualSeller.gst) + individualSeller.price) + deliChrg)
  };

  const medicineFunction1 = async (data, key, value) => {
    data.key =
      key === "ethical"
        ? "Ethical branded"
        : key === "cool"
          ? "Cool chain"
          : key === "generic"
            ? "Generic"
            : "Others";
    let prodCod = value && value.filter((e) => e.isPrepaid === true);
    let invenCod =
      value &&
      value.filter((e) => e.prepaidInven === true || e.isBulk === true);
    let med = mediData && mediData.filter((e) => e.name === data.key);
    data.medicineId = med[0]._id;
    data.showCod = med[0].onlyPrepaid;
    data.showCodForProd = prodCod.length > 0 ? true : false;
    data.showCodForInven = invenCod.length > 0 ? true : false;
    setMediTypeData(data);
    setMedicinePop(true);
    let value3 =
      data.key === "Cool chain"
        ? data.coolChain + data.coolChainGst
        : data.key === "Ethical branded"
          ? data.ethical + data.ethicalGst
          : data.key === "Generic"
            ? data.generic + data.genericGst
            : 0;

    let value1 =
      data.key === "Cool chain"
        ? data.coolChain + data.coolChainGst
        : data.key === "Ethical branded"
          ? data.ethical + data.ethicalGst
          : data.key === "Generic"
            ? data.generic + data.genericGst
            : 0;

    let calculatedVal =
      individualDeliveryChrg > 0
        ? value3 + Number(individualDeliveryChrg || 0)
        : value1;
    console.log("ddddddddddddd145", calculatedVal);
    setProdChekOutVal(calculatedVal);
  };
  let individualDeliveryChrg = 0;

  const medicineFunction = async (data, key, value, event) => {
    // The order-type checkout. Claims (and celebrates) ONLY the vouchers on this seller's products
    // of this order type - `key` is 'cool' for the cool-chain order and 'ethical'/'generic' for the
    // one everything else ships in. The seller's other order type is deliberately left as it was:
    // the buyer is not paying for it here, so its vouchers stay on offer until they check that one
    // out or claim it from the modal.
    autoApplyVouchersAtCheckout(
      data && data.ID,
      event,
      key === "cool" ? "cool" : "other",
    );
    setShowCodOption(true);
    setMediprepayment(0);
    // Combine "Generic" into "Ethical branded"
    data.key =
      key === "ethical" || key === "generic"
        ? "Ethical branded"
        : key === "cool"
          ? "Cool chain"
          : "Others";
    if (key === "ethical" || key === "generic") {
      const sumEthical = (data.ethical || 0) + (Number(data.generic) || 0);
      if (
        sumEthical >= deliveryMinRange?.value &&
        sumEthical < deliveryMaxRange?.value
      ) {
        individualDeliveryChrg = Number(newGlobalDeliveryCrg?.value);
        setShowCodOption(false);
      } else {
        individualDeliveryChrg = users?.isDeliveryCharge
          ? Number(globalDeliveryCrg.value)
          : 0;
      }
    } else if (key === "cool") {
      if (
        data.coolChain >= deliveryMinRange?.value &&
        data.coolChain < deliveryMaxRange?.value
      ) {
        individualDeliveryChrg = Number(newGlobalDeliveryCrg?.value);
        setShowCodOption(false);
      } else {
        individualDeliveryChrg = users?.isDeliveryCharge
          ? Number(globalDeliveryCrg.value)
          : 0;
      }
    }
    setIndividualCharges(individualDeliveryChrg);
    // Prepaid and Inventory filtering (same as before)
    let prodCod = value && value.filter((e) => e.isPrepaid === true);
    let invenCod =
      value &&
      value.filter((e) => e.prepaidInven === true || e.isBulk === true);

    let med = mediData && mediData.filter((e) => e.name === data.key);
    data.medicineId = med[0]?._id;
    data.showCod = med[0]?.onlyPrepaid;

    data.showCodForProd = prodCod.length > 0;
    data.showCodForInven = invenCod.length > 0;

    setMediTypeData(data);
    setMedicinePop(true);

    // Total value calculation (combining generic into ethical)
    const ParicalPayemntVal = data.ethical + (data.ethicalGst || 0);
    let value3 =
      data.key === "Cool chain"
        ? data.coolChain + data.coolChainGst
        : data.key === "Ethical branded"
          ? data.ethical +
            data.ethicalGst +
            Number(data.generic || 0) +
            Number(data.genericGst || 0)
          : 0;

    let value1 = value3;

    const blockLiquidSurcharge =
      data.key === "Cool chain"
        ? Number(data.coolChainLiquidSurcharge || 0)
        : Number(data.ethicalLiquidSurcharge || 0);
    const blockCoupons = Number(
      (blockSavings[`${data.ID}|${key === "cool" ? "cool" : "other"}`] || {})
        .coupons || 0,
    );
    let calculatedVal = Math.max(
      0,
      (individualDeliveryChrg > 0
        ? value3 + Number(individualDeliveryChrg || 0)
        : value1) +
        blockLiquidSurcharge -
        blockCoupons,
    );

    setProdChekOutVal(calculatedVal);
    let PrtialCod =
      Math.ceil(
        ((ParicalPayemntVal || 0) *
          ((users.codPrepayPer ? users.codPrepayPer : 0) / 100)) /
          100,
      ) * 100;
    PrtialCod = PrtialCod < 500 ? 500 : PrtialCod;
    setMediprepayment(PrtialCod);
  };

  const activeButton = (data) => {
    let cool = true;
    let ethic = true;
    let gene = true;
    if (data.coolChain > 0 && data.coolChain < coolChainData.minOrder) {
      cool = false;
    }
    if (data.ethical > 0 && data.ethical < ethicalData.minOrder) {
      ethic = false;
    }
    // if (data.generic > 0 && data.generic < genericData.minOrder) {
    //   gene = false;
    // }
    if (cool && ethic && gene) {
      return true;
    } else {
      return false;
    }
  };

  const short = (type, data) => {
    if (
      type === "coolChain" &&
      data.coolChain > 0 &&
      data.coolChain < coolChainData.minOrder
    ) {
      return true;
    }
    if (
      type === "ethicalBranded" &&
      data.ethical > 0 &&
      data.ethical < ethicalData.minOrder
    ) {
      return true;
    }
    if (
      type === "generic" &&
      data.generic > 0 &&
      data.generic < genericData.minOrder
    ) {
      return true;
    }
    return false;
  };

  const getOtp = async () => {
    setSet(true);
    let data = {
      type: "Order",
      action: "OTP for BNPL order.",
      counter: 1,
      typeId: null,
    };
    const result = await axios({
      method: "post",
      url: `${AppConfig.baseUrl}systemActivity/addActivity`,
      headers: {
        "Content-Type": "application/json",
        token: localStorage.getItem("buyer_token"),
      },
      data: data,
    });
    if (result.data.error) {
      NotificationManager.error(result.data.title);
    } else {
      setOtpId(result.data.id);
      NotificationManager.success(result.data.title);
    }
  };

  const isUserLoggedIn = localStorage.getItem("buyer_token");
  const { cartDetails } = props;
  const threeMonth = new Date(moment().add(3, "M")).getTime();
  let singleItemTotalGST = 0;
  let GlobalCodOption = [];
  let AllItemsTotalPrice = 0;
  let AllItemsTotalGST = 0;
  // The liquid surcharge across the whole cart, accumulated line by line beside AllItemsTotalGST
  // below - the same shape, on the same ex-GST base. Previews what the API will charge; see
  // util/liquidSurcharge.
  let AllItemsLiquidSurcharge = 0;
  let GST = 0;
  let one = [];
  let j = 1;
  let discountMinus = 0;
  let priceAfterDiscount = 0;
  let newGST = 0;
  let totalDiscountMinus = 0;
  let finalGST = 0;
  let data = [];
  let sellerDetails = [];
  let total = 0;
  // The voucher-adjusted amount actually due - mirrors the Payable line (Items Total + reduced GST
  // + delivery, less the claimed coupons/cashback). Filled during render once the item totals are
  // summed, then reused by every "what you owe" row so the whole card agrees with Payable. `total`
  // stays the pre-voucher gross because the COD/BNPL eligibility gates below are still keyed to it.
  let payableAmount = 0;
  let singleItemTotalPrice;
  let cartCouponSaving = 0; // product-coupon deduction, INCL-GST (a flat cut off the payable)
  let cartGiftCount = 0;
  // (sellerID, block) => the order-value offers on that checkout block (seller cashback and/or
  // Medimny's platform discount). Defined inside the logged-in branch below, where the lines exist.
  let sellerOffer = () => [];
  // The voucher rows behind the claim modal, grouped by who funds them, and what they are worth
  // per tier. Both are filled in the logged-in branch below, alongside sellerOffer.
  let voucherGroups = [];
  // The claim modal is opened per ORDER-TYPE BLOCK (Cool chain vs the rest). One entry per checkout
  // block that carries anything to show - product coupons/gifts and/or a Medimny/seller value tier.
  let voucherBlockGroups = [];
  /*
  The `sellerId|block` keys whose block carries an UNLOCKED value-tier reward - a seller cashback, a
  platform cashback, or a store-wide gift from either.

  These never appear in the Applicable Vouchers modal: value-tier rewards are auto-applied, not
  claimed row by row. But a checkout press attaches them exactly as it attaches a product coupon, and
  it is the only place they can be attached, so the blocks they sit in have to be claimable - and
  celebrated - on their own. Without this list a seller running a cashback but no product campaign
  checked out in silence: `claimedBlockKeys` was built from product rows alone, so there were no
  winners, no confetti, no toast, and their card never revealed the cashback the buyer had just
  earned.

  Filled in the same pass that prices the tiers, so it is ready before any handler can fire.
  */
  let valueTierBlockKeys = [];
  // Each row's Claim button is disabled off `claimedVoucherKeys` - whether THAT row has been
  // pressed. It must NOT key off the row's `applied` flag: that means "eligible / will be applied"
  // (product coupons always are, unlocked cashbacks too), so on a fresh load, before any claim,
  // every row already reads as applied and would wrongly show as already claimed.
  // What the three tiers are worth on this cart. One figure per tier now, not two: the coupon is a
  // flat INCL-GST cut off the payable, so there is no ex-GST/grossed-up pair to keep in step and no
  // GST to recompute. `coupons` is the only one that reduces what the buyer pays here; cashback and
  // platform are ex-GST rewards credited to the MediWallet on delivery and are shown as notes.
  // `gifts` is a COUNT, not rupees, and it is the reason it has to be carried separately: a gift is
  // worth nothing off the payable, so it contributes 0 to `total`. Every "is there a reward on this
  // cart?" test used to read `total` alone, which made a gift-only cart indistinguishable from an
  // empty-handed one - it never claimed, and the checkout never mentioned the gift the buyer was in
  // fact getting. Counting them here is what lets those tests ask the right question.
  let tierSavings = {
    coupons: 0,
    cashback: 0,
    platform: 0,
    gifts: 0,
    total: 0,
  };
  // "Is this cart carrying ANY reward worth telling the buyer about?" - rupees or a gift. Read by the
  // claim gates and by every reveal below, in place of the old `tierSavings.total > 0`.
  const hasAnyReward = () => tierSavings.total > 0 || tierSavings.gifts > 0;

  // The same three tiers, split PER SELLER (keyed by seller user_id) so a single seller's checkout
  // modal can price in only the vouchers that belong to that seller's order.
  let sellerSavings = {};
  const addSellerSaving = (uid, field, amt) => {
    const k = String(uid);
    if (!sellerSavings[k])
      sellerSavings[k] = {
        coupons: 0,
        cashback: 0,
        platform: 0,
      };
    sellerSavings[k][field] += amt;
  };
  // Same split, one level finer: keyed by `${user_id}|${block}` (block = 'cool' | 'other'), because
  // the medicine-type checkout modal orders ONE block of a seller at a time. 'Cool chain' -> cool,
  // 'Ethical branded' (ethical + generic, combined at checkout) -> other.
  let blockSavings = {};
  const addBlockSaving = (uid, block, field, amt) => {
    const k = `${uid}|${block}`;
    if (!blockSavings[k])
      blockSavings[k] = {
        coupons: 0,
        cashback: 0,
        platform: 0,
      };
    blockSavings[k][field] += amt;
  };
  // The open seller-checkout modal's voucher split and the payable derived from it (mirrors the main
  // summary). Filled by an IIFE inside that modal. No reduced-GST figure any more: GST stands as
  // charged and the coupon comes off after it.
  let sellerVoucher = {
    coupons: 0,
    cashback: 0,
    platform: 0,
  };
  let sellerHasDiscount = false;
  let sellerPayable = 0;
  // The liquid surcharge on the open seller / medicine-type checkout. Resolved where each payable is
  // computed below, and shown as its own row beside that block's delivery charge.
  let sellerLiquidSurcharge = 0;
  let mediLiquidSurcharge = 0;
  // Whether THAT seller's vouchers have been claimed - what gates the cashback rows below, so the
  // card reveals its savings only once the buyer has claimed from this seller.
  let sellerClaimed = false;
  // Same, for the open medicine-type modal (one seller + one block).
  let mediVoucher = { coupons: 0, cashback: 0, platform: 0 };
  let mediHasDiscount = false;
  let mediPayable = 0;
  let mediClaimed = false;

  const inr = (v) =>
    Number(v || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  /*
  The band a percentage cashback pays in, in words: "at least X" for the guaranteed floor, "up to Y"
  for the ceiling above which nothing more is earned. Returns the inside of the bracket, or '' when
  the campaign carries neither end.

  Both halves are conditional, which is the reason this is built in one place rather than spelled out
  at each banner: only the 'minimum' type guarantees a floor, and a campaign approved before
  `cashback_max` existed carries no ceiling. So a floored campaign reads "at least ₹150, up to ₹500",
  a plain percentage reads "up to ₹500", and a legacy one falls back to no bracket at all rather than
  printing "up to ₹0" - which would read as a cashback of nothing.

  Shared by the platform card at the top of the cart and by the per-block seller/platform banners in
  BOTH states (locked and unlocked), so every place the cart quotes an offer quotes it the same way.
  */
  const cashbackBand = (type, floor, max) =>
    [
      type === "minimum" && Number(floor) > 0 ? `at least ₹${inr(floor)}` : "",
      Number(max) > 0 ? `up to ₹${inr(max)}` : "",
    ]
      .filter(Boolean)
      .join(", ");

  /*
  A gift campaign that carries a picture makes its banner clickable: hovering says so, clicking
  opens the picture over the cart. Same behaviour as the "Free Gift" label on the product page, so a
  buyer who learned it there does not have to learn it again here.

  Split in two because the banners differ in markup but not in behaviour: `giftClickProps` supplies
  what the banner element needs, `withGiftImageTip` wraps whatever came out in the tooltip. Both
  no-op when the campaign has no picture, leaving the banner exactly as inert as it was.
  */
  const giftImageOf = (gift) =>
    gift && typeof gift.image === "string" && gift.image ? gift.image : "";

  const giftClickProps = (gift) => {
    if (!giftImageOf(gift)) return { style: {}, handlers: {} };
    const open = () => setGiftView(gift);
    return {
      style: { cursor: "pointer" },
      handlers: {
        onClick: open,
        role: "button",
        tabIndex: 0,
        onKeyDown: (e) => {
          if (e.key === "Enter" || e.key === " ") open();
        },
      },
    };
  };

  const withGiftImageTip = (node, gift, key) =>
    giftImageOf(gift) ? (
      <Tooltip
        key={key}
        title="Click to view the image"
        arrow
        // MUI's default tooltip is 11px with 4px of padding - fine for an icon hint, far too small
        // against a 17px banner, where it reads as a stray label rather than an instruction.
        componentsProps={{
          tooltip: {
            sx: { fontSize: 15, fontWeight: 500, p: "9px 14px", lineHeight: 1.4 },
          },
        }}
      >
        {node}
      </Tooltip>
    ) : (
      node
    );

  // Shown against a single checkout block, because that block is what becomes one order and both
  // minimums are assessed per order. Anchoring this to the seller's whole basket instead would
  // promise a discount the buyer will not actually get once the basket splits into separate orders.
  //
  // The two tiers stack, so both can appear on one block. They are worded differently on purpose -
  // a buyer should be able to tell a seller's offer from a Medimny one.
  const offerBanner = (offers) => {
    const list = Array.isArray(offers)
      ? offers.filter(Boolean)
      : offers
        ? [offers]
        : [];
    if (!list.length) return null;

    return list.map((offer, i) => {
      const isPlatform = offer.label === "platform";
      const who = isPlatform ? "Medimny" : "Seller";
      // Who funds it, and therefore where the extra spend has to come from. The platform minimum is
      // assessed on the whole order; the seller's only counts what this seller supplies.
      const from = isPlatform ? "from Medimny" : "from this seller";
      // A gift is worth what the seller declared it is worth, and that figure is the whole reason a
      // buyer stretches for it - so it is named here rather than left to the campaign's small print.
      // The brand carries the same weight in pharma retail: "a bottle" and "a Milton bottle" are not
      // the same offer. Both drop out silently when the campaign did not record them.
      const giftName =
        (offer.gift && offer.gift.description) || "a free gift";
      const giftBrand =
        offer.gift && offer.gift.brand ? ` by ${offer.gift.brand}` : "";
      const giftWorth =
        offer.gift && Number(offer.gift.price) > 0
          ? ` worth ₹${inr(offer.gift.price)}`
          : "";
      /*
      The threshold itself, alongside the gap to it. "Add ₹2,400 more" tells a buyer what to do but
      not what the bar is, so both tiers name their minimum here. Medimny's is also on the campaign
      card above the seller blocks, but that card speaks for the whole cart while this banner is the
      only place the minimum is reported against the checkout it is actually assessed on.

      Whose minimum it is has to be said, because the two are assessed on different money: the
      seller's counts only what this seller supplies, Medimny's counts the whole order. Ex-GST, like
      every other figure on this banner.
      */
      const movNote =
        Number(offer.mov) > 0
          ? `${isPlatform ? "Medimny's" : "This seller's"} minimum order value is ₹${inr(offer.mov)}. `
          : "";

      /*
      How the cashback is worked out, as the campaign was set up: the percentage, and the band it
      pays in - the floor under it when one is guaranteed, and the ceiling above it. The rupee figure
      this banner leads with is only what those terms come to on the current basket, so without this
      a buyer cannot tell a 2% offer that happens to pay ₹1,500 today from a flat ₹1,500 one.

      The ceiling belongs here as much as the floor, and for the opposite reason: the floor is what a
      small basket still earns, while the ceiling is where adding another line stops paying. A buyer
      weighing whether to stretch the order needs both ends of that band, not just the guarantee.

      A flat campaign is skipped deliberately - its terms and its amount are the same number, which
      the banner has already said. A gift carries no cashback terms at all. Both fall through to ''
      and the sub-line reads exactly as it did before.
      */
      const termsNote = (() => {
        if (offer.isGift || !(Number(offer.cashbackPercent) > 0)) return "";
        const band = cashbackBand(
          offer.cashbackType,
          offer.cashbackFloor,
          offer.cashbackMax
        );
        return band
          ? `${offer.cashbackPercent}% cashback (${band}). `
          : `${offer.cashbackPercent}% cashback. `;
      })();
      const key = `${offer.label}-${i}`;
      // Sized above the surrounding cart text on purpose: this card carries the money the buyer
      // earns (or is one nudge away from earning), so it has to be readable without hunting for it.
      const box = { borderRadius: 4, fontSize: 17 };
      // A gift banner opens its picture, exactly as the "Free Gift" label on the product page does.
      // Whether the campaign is locked or unlocked makes no difference: a buyer deciding whether to
      // stretch for a gift wants to see it most of all BEFORE they have earned it.
      const gift = offer.isGift ? offer.gift : null;
      const clickable = giftClickProps(gift);

      if (offer.unlocked) {
        // Medimny offers are tinted differently so the buyer can see who is paying
        const accent = isPlatform ? "#072791" : "#0f7a4e";
        const bg = isPlatform ? "#e8edf9" : "#e8f5ee";
        return withGiftImageTip(
          <div
            key={key}
            className="ml-3 mr-3 mb-2 mt-3 p-2"
            style={{
              ...box,
              background: bg,
              ...clickable.style,
            }}
            {...clickable.handlers}
          >
            <span style={{ fontWeight: 600, color: accent }}>
              {offer.isGift
                ? `Unlocked: ${giftName}${giftBrand}${giftWorth}, free ${from}`
                : `Unlocked: ₹${inr(offer.cashback)} ${who} cashback on this order`}
            </span>
            {/* Where the reward actually lands. Neither cashback comes off what the buyer pays
                today - both are MediWallet credits on delivery - and saying "applied at checkout"
                had them looking for it on the payable. */}
            <div style={{ fontWeight: 600, color: "#000", fontSize: 15 }}>
              {termsNote}
              {movNote}
              {/* {offer.isGift
                ? "Packed with this order automatically. Nothing to claim."
                : "Credited to your MediWallet once this order is delivered."} */}
                {offer.isGift && "Packed with this order automatically. Nothing to claim."}
            </div>
          </div>,
          gift,
          key,
        );
      }

      return withGiftImageTip(
        <div
          key={key}
          className="ml-3 mr-3 mb-2 mt-3 p-2"
          style={{
            ...box,
            background: "#fff6e5",
            ...clickable.style,
          }}
          {...clickable.handlers}
        >
          {/* Ends on what the buyer gets, not on what they have to do: the reward is the reason to
              add more, so it carries the emphasis and the closing words. */}
          Add <strong>₹{inr(offer.shortfall)}</strong> more
          {isPlatform ? " to this order" : " from this seller"} and{" "}
          {offer.isGift ? (
            <React.Fragment>
              <strong>
                {giftName}
                {giftBrand}
                {giftWorth}
              </strong>{" "}
              is yours, free {from}.
            </React.Fragment>
          ) : (
            <React.Fragment>
              <strong>
                ₹{inr(offer.cashbackAtMov)} {who} cashback
              </strong>{" "}
              is yours.
            </React.Fragment>
          )}
          <div style={{ fontWeight: 600, color: "#000", fontSize: 15 }}>
            {termsNote}
            {movNote}
            Measured on this checkout alone, excluding GST and after any discount
            above it.
          </div>
        </div>,
        gift,
        key,
      );
    });
  };

  /*
  Medimny's own site-wide campaign, shown once above the seller blocks.

  It belongs there rather than inside one of them because it is not a seller's offer: it applies to
  every order in this cart that clears its minimum, whoever is selling. The per-block banners below
  still report the progress towards it on each individual checkout, which is where the minimum is
  actually assessed - this card only announces that the campaign exists and what it pays.

  The API hangs the same platform campaign on every cart line, so the first line carrying one
  describes the whole cart.
  */
  const platformCampaign =
    (cartDetails && cartDetails.detail ? cartDetails.detail : [])
      .map((line) => line && line.platformCampaign)
      .find(Boolean) || null;

  // One line naming what Medimny is giving, worded the way the campaign was set up.
  const platformReward = (c) => {
    if (c.type === "gift") {
      const gift = c.gift || {};
      // Same phrasing as the per-block banners below: what it is, whose brand, what it is worth.
      // Each part drops out silently when the campaign did not record it.
      const name = gift.description ? `: ${gift.description}` : "";
      const brand = gift.brand ? ` by ${gift.brand}` : "";
      const worth = Number(gift.price) > 0 ? ` worth ₹${inr(gift.price)}` : "";
      return `Free gift${name}${brand}${worth}`;
    }
    if (c.cashback_type === "flat") return `Flat ₹${inr(c.cashback_value)} off`;
    // Both percentage types name their band the same way - "at least" for the guaranteed floor,
    // "up to" for the ceiling - so a buyer reads one wording wherever the offer appears.
    const band = cashbackBand(c.cashback_type, c.cashback_floor, c.cashback_max);
    return band
      ? `${c.cashback_percent}% off (${band})`
      : `${c.cashback_percent}% off`;
  };

  const platformOfferCard = () => {
    if (!platformCampaign) return null;
    const isGift = platformCampaign.type === "gift";
    // Same click-to-see-it behaviour as the per-block banners below.
    const gift = isGift ? platformCampaign.gift : null;
    const clickable = giftClickProps(gift);
    return withGiftImageTip(
      <div
        className="mb-3 p-3"
        style={{
          borderRadius: 4,
          background: "#e8edf9",
          border: "1px solid #ccd6ef",
          ...clickable.style,
        }}
        {...clickable.handlers}
      >
        <div style={{ fontWeight: 600, color: "#072791", fontSize: 17 }}>
          <span aria-hidden="true" style={{ marginRight: 8 }}>
            {isGift ? "🎁" : "💰"}
          </span>
          Medimny offer: {platformReward(platformCampaign)}
        </div>
        {/* The condition the offer hangs on, so it is set bold and a step above the cart's body
            size rather than as a caption under the headline. Same on a gift campaign as on a
            cashback one - the qualifying order is the same fact either way. */}
        <div style={{ fontWeight: 600, color: "#000", fontSize: 15, marginTop: 2 }}>
          On every order above ₹{inr(platformCampaign.min_order_value)}{" "}
          (excluding GST), from any seller.
        </div>
        {/* A gift's line stays: WHEN it arrives is the only thing left to say about one. The
            cashback's "credited once delivered" has moved out to the card below this one, where it
            speaks for the seller's cashback too - saying it here as well would say it twice on a
            cart carrying both. */}
        {isGift ? (
          <div style={{ fontWeight: 600, color: "#000", fontSize: 15 }}>
            Added to the order automatically when you place it.
          </div>
        ) : null}
      </div>,
      gift,
      "platform-offer-card",
    );
  };

  /*
  When a cashback is credited, said once for the whole cart.

  It sits under the Medimny offer banner, built the same way, because it is the same kind of statement:
  something about the rewards on this cart rather than about any one seller's block. It used to be a
  line inside that banner and a note under the cashback rows of all three summary tables - four places
  saying one thing, and none of them covering both tiers at once.

  Shown whenever a cashback of EITHER tier is on the cart, whether or not the order has cleared its
  minimum yet: a buyer reading a shortfall banner is being told what they would earn, and this is when
  it would reach them. A gift-only campaign shows nothing here - a gift is not credited anywhere, it
  ships with the order, which its own banner says.
  */
  const cashbackWalletNoteCard = () => {
    const lines = cartDetails && cartDetails.detail ? cartDetails.detail : [];
    const hasSellerCashback = lines.some(
      (line) => line && line.sellerCampaign && line.sellerCampaign.type !== "gift",
    );
    const hasPlatformCashback = Boolean(
      platformCampaign && platformCampaign.type !== "gift",
    );
    if (!hasSellerCashback && !hasPlatformCashback) return null;
    return (
      <div
        className="mb-3 p-3"
        style={{
          borderRadius: 4,
          background: "#e8edf9",
          border: "1px solid #ccd6ef",
        }}
      >
        {/* Set like the reward banners around it - 17px, semibold, in the Medimny blue - because it
            is the same kind of statement about the buyer's money, and it read as fine print next to
            them at the cart's body size. */}
        <div style={{ fontWeight: 600, color: "#072791", fontSize: 17 }}>
          <span aria-hidden="true" style={{ marginRight: 8 }}>
            💳
          </span>
          {CASHBACK_WALLET_NOTE}
        </div>
      </div>
    );
  };

  const { users } = props;
  // let individualDeliveryChrg = users && users.isDeliveryCharge === true ? Number(globalDeliveryCrg.value) : 0;
  const isLogined = localStorage.getItem("buyer_token");
  let removeInventoryLists = [];
  let isCoolChain;
  let isPrepaid = [];
  let prepaidInvenAll;
  let PrtialCod = 0;
  const isCodPrepayValid = users.isCodPrepay && users.codPrepayPer > 0;

  if (isLogined) {
    cartDetails &&
      cartDetails.detail &&
      cartDetails.detail.length > 0 &&
      cartDetails.detail.map((dataOne, index) => {
        data.push({
          image: dataOne.Inventory.product_id.images[0],
          title: dataOne.Inventory.product_id.name,
          time: dataOne.Inventory.updatedAt,
          seller_id: dataOne.Seller.company_name,
          sellerID: dataOne.Seller._id,
          sellerStatus: dataOne.Seller.user_status,
          sellerVac: dataOne.Seller.vaccation.vaccationMode,
          price: dataOne.Inventory.PTR,
          gstPercentage: dataOne.Inventory.product_id.gst.value,
          // The liquid surcharge RATE for this line, read straight off the product the same way the
          // GST rate above is. 0 on everything that is not a Liquid product - the API only ever
          // stores a rate on those - so the cart never has to know about product types.
          liquidSurchargePercentage: liquidSurchargeRate(dataOne.Inventory.product_id),
          quantity: dataOne.cart_details.quantity,
          stock: 0,
          inventory_id: dataOne.Inventory._id,
          // the live product-level coupon/gift on this listing (null when none). The discount is not
          // applied to the cart price - it is taken off at order placement - so the cart only tells
          // the buyer what they are about to save.
          activeCoupon: dataOne.activeCoupon ? dataOne.activeCoupon : null,
          discount: dataOne.Discount ? dataOne.Discount : {},
          discountPercentage: dataOne.Discount.discount_per,
          min_order_quantity: dataOne.Inventory.min_order_quantity,
          max_order_quantity: dataOne.Inventory.max_order_quantity,
          user_id: dataOne.Inventory.user_id,
          inventory: dataOne.Inventory ? dataOne.Inventory : {},
          discountProduct: dataOne.DiscountProduct
            ? dataOne.DiscountProduct
            : {},
          isPrepaid: dataOne.Inventory.product_id.isPrepaid
            ? dataOne.Inventory.product_id.isPrepaid
            : false,
          prepaidInven: dataOne.Inventory.prepaidInven
            ? dataOne.Inventory.prepaidInven
            : false,
          isBulk: dataOne.Inventory.isBulk ? dataOne.Inventory.isBulk : false,
        });
      });

    // Product coupons are granted per LOT (the listing's min order quantity), not per unit:
    // floor(qty / lotSize) lots, each worth coupon_value. lotSize falls back to 1 when the listing
    // has no min order quantity, matching the API's order-placement maths.
    const couponLots = (quantity, lotSize) => {
      const size = Number(lotSize) > 0 ? Number(lotSize) : 1;
      return Math.floor((Number(quantity) || 0) / size);
    };

    // What the product-level coupons on this cart will take off at checkout. Computed from the raw
    // cart response rather than the pricing pipeline above, because the discount is applied at order
    // placement - it never touches the cart prices themselves.
    //
    // ONE figure per coupon: its face value, taken straight off the GST-inclusive payable. No
    // grossing-up by the line's GST rate any more - the coupon no longer reduces the taxable value,
    // so a 120 coupon is worth 120 to the buyer and that is what is shown. Mirrors the API's
    // applyCouponsToOrder.
    cartCouponSaving = (
      cartDetails && cartDetails.detail ? cartDetails.detail : []
    ).reduce((sum, line) => {
      const c = line.activeCoupon;
      if (!c || c.type !== "coupon") return sum;
      const qty = Number(line.cart_details && line.cart_details.quantity) || 0;
      const lots = couponLots(
        qty,
        line.Inventory && line.Inventory.min_order_quantity,
      );
      const off = (Number(c.coupon_value) || 0) * lots;
      const uid = line.Inventory && line.Inventory.user_id;
      const lineBlock =
        (line.Inventory && line.Inventory.medicineTypeName) === "Cool chain"
          ? "cool"
          : "other";
      addSellerSaving(uid, "coupons", off);
      addBlockSaving(uid, lineBlock, "coupons", off);
      return sum + off;
    }, 0);
    /*
    Product-level gifts on this cart, counted and split the same way the coupon saving above is.

    A gift is worth no rupees off the payable, so it never appeared in any of the savings figures -
    and because every "does this cart carry a reward?" test read those figures, a cart whose ONLY
    reward was a gift behaved exactly like a cart with none: it never claimed, and no checkout screen
    mentioned the gift the buyer was in fact being given. Counting them is what fixes that.
    */
    cartGiftCount = (
      cartDetails && cartDetails.detail ? cartDetails.detail : []
    ).reduce((count, line) => {
      const c = line.activeCoupon;
      if (!c || c.type !== "gift") return count;
      return count + 1;
    }, 0);

    let totalItemsInCart = [];
    cartDetails &&
      cartDetails.detail &&
      cartDetails.detail.length > 0 &&
      cartDetails.detail.map((dataOne, index) => {
        // The line's EX-GST value, lifted out of the object literal because three fields now need
        // it: `price`, `gstValue` and `liquidSurchargeValue` are all assessed on this one figure.
        const lineExGst =
          dataOne.Discount &&
          dataOne.Discount.type === "Discount" &&
          dataOne.Discount.discount_per
            ? dataOne.Inventory.ePTR * dataOne.cart_details.quantity
            : dataOne.Discount &&
                (dataOne.Discount.type === "Same" ||
                  dataOne.Discount.type === "SameAndDiscount")
              ? ((dataOne.cart_details.quantity /
                  dataOne.Discount.discount_on_product.purchase) *
                  dataOne.Discount.discount_on_product.bonus +
                  dataOne.cart_details.quantity) *
                dataOne.Inventory.ePTR
              : dataOne.Inventory.ePTR * dataOne.cart_details.quantity;
        totalItemsInCart.push({
          user_id: dataOne.Inventory.user_id,
          price: lineExGst,
          // This line's share of the cart's liquid surcharge, so the per-seller and per-medicine-type
          // checkout blocks below can total it the way they total `gstValue`. 0 on non-liquid lines.
          liquidSurchargeValue: liquidSurchargeForLine(
            liquidSurchargeRate(dataOne.Inventory.product_id),
            lineExGst,
          ),
          seller_name: dataOne.Seller.company_name,
          inventory_id: dataOne.Inventory._id,
          discount_type: dataOne.Discount.type,
          discount_per:
            dataOne.Discount && dataOne.Discount.discount_per
              ? dataOne.Discount.discount_per
              : "noPercentage",
          gstValue:
            dataOne.Discount &&
            (dataOne.Discount.type === "Same" ||
              dataOne.Discount.type === "SameAndDiscount")
              ? ((dataOne.Inventory.ePTR *
                  ((dataOne.cart_details.quantity /
                    dataOne.Discount.discount_on_product.purchase) *
                    dataOne.Discount.discount_on_product.bonus +
                    dataOne.cart_details.quantity)) /
                  100) *
                dataOne.Inventory.product_id.gst.value
              : ((dataOne.Inventory.ePTR * dataOne.cart_details.quantity) /
                  100) *
                dataOne.Inventory.product_id.gst.value,
          mediType: dataOne.Inventory.medicineTypeName,
          // No per-line coupon figure is carried here any more: the value tiers are assessed on the
          // GROSS ex-GST goods value and the product coupon no longer trims it (see sellerOffer).
          sellerCampaign: dataOne.sellerCampaign
            ? dataOne.sellerCampaign
            : null,
          platformCampaign: dataOne.platformCampaign
            ? dataOne.platformCampaign
            : null,
          isPrepaid: dataOne.Inventory.product_id.isPrepaid
            ? dataOne.Inventory.product_id.isPrepaid
            : false,
          prepaidInven: dataOne.Inventory.prepaidInven
            ? dataOne.Inventory.prepaidInven
            : false,
          isBulk: dataOne.Inventory.isBulk ? dataOne.Inventory.isBulk : false,
        });
      });

    /*
    Preview of the two order-value tiers: the seller's store-wide cashback, and Medimny's
    platform-wide discount. They STACK - the seller cashback comes off first, then the platform
    discount comes off what is left - so a checkout block can legitimately show both.

    The unit matters and is easy to get wrong: an order is one seller AND one medicine-type bucket
    (cool chain is split from the rest), and both minimums are assessed PER ORDER. So the progress
    must be measured against each checkout block - the thing that actually becomes an order - and
    never against the seller's whole basket, or a buyer would be told they qualify when they do not.

    The basis mirrors the API exactly: ex-GST value, less the discounts from the tiers above.
    */
    const r2 = (n) =>
      Math.round(((Number(n) || 0) + Number.EPSILON) * 100) / 100;

    // Mirrors the API's computeCashback: the MOV qualifies on `movBasis` (gross ex-GST, before any
    // tier discount above this one) while a % cashback is computed on `payBasis` (net of those
    // discounts). When payBasis is omitted the two collapse to the same figure.
    const cashbackFor = (campaign, movBasis, payBasis) => {
      if (!campaign) return 0;
      const gate = Number(movBasis) || 0;
      const base = payBasis === undefined ? gate : Number(payBasis) || 0;
      if (gate < (Number(campaign.min_order_value) || 0)) return 0;
      const pct = (Number(campaign.cashback_percent) || 0) / 100;
      let raw;
      if (campaign.cashback_type === "flat")
        raw = Number(campaign.cashback_value) || 0;
      else if (campaign.cashback_type === "proportionate") {
        raw = base * pct;
        // Capped at the ceiling, mirroring the API's computeCashback: a buyer never earns more than
        // `cashback_max` however large the basket, so the banner must not promise more either.
        if (Number(campaign.cashback_max) > 0) raw = Math.min(raw, Number(campaign.cashback_max));
      } else if (campaign.cashback_type === "minimum") {
        raw = Math.max(base * pct, Number(campaign.cashback_floor) || 0);
        // floored at the guarantee, capped at the ceiling - the payout sits in the [floor, max] band,
        // mirroring the API's computeCashback so the banner never promises above the cap.
        if (Number(campaign.cashback_max) > 0) raw = Math.min(raw, Number(campaign.cashback_max));
      } else return 0;
      // A cashback is a whole number of rupees - the API rounds it the same way in
      // models/productCoupon.js computeCashback. This mirror has to round too, or the banner would
      // promise a figure with paise on it that the wallet is never credited.
      return Math.round(raw);
    };

    // one campaign -> one offer. `grossBasis` gates the MOV (ex-GST before any tier discount above
    // this one); `payBasis` is the net figure a % cashback is computed on.
    const offerFor = (campaign, grossBasis, payBasis, label) => {
      if (!campaign) return null;
      const mov = Number(campaign.min_order_value) || 0;
      const isGift = campaign.type === "gift";
      /*
      Everything that does not depend on whether the minimum has been cleared: which tier it is,
      what the reward is, and the TERMS the campaign was set up with.

      The terms are carried because the rupee figure the banner leads with is only what they come to
      on this basket - change the basket and it changes. "2% with ₹500 guaranteed" is the offer
      itself, and a buyer deciding whether to add another line needs the rule, not just today's
      instance of it. Shared by both states so an unlocked banner explains its number too.
      */
      const terms = {
        label,
        isGift,
        mov,
        gift: campaign.gift,
        cashbackType: campaign.cashback_type,
        cashbackPercent: Number(campaign.cashback_percent) || 0,
        cashbackFloor: Number(campaign.cashback_floor) || 0,
        cashbackMax: Number(campaign.cashback_max) || 0,
      };
      if (grossBasis >= mov) {
        return {
          ...terms,
          unlocked: true,
          cashback: r2(cashbackFor(campaign, grossBasis, payBasis)),
        };
      }
      return {
        ...terms,
        unlocked: false,
        shortfall: r2(mov - grossBasis),
        // what they'd get if they topped up to exactly the MOV - concrete beats abstract. Topping the
        // GROSS up to the MOV raises the net pay basis by the same amount (the added goods carry no
        // discount above this tier), so the payout is assessed on payBasis + that shortfall.
        cashbackAtMov: r2(
          cashbackFor(campaign, mov, r2(payBasis + (mov - grossBasis))),
        ),
      };
    };

    // `block` is 'cool' for the Cool Chain checkout, anything else for the Medical & Surgical one
    sellerOffer = (sellerID, block) => {
      const lines = totalItemsInCart.filter(
        (e) =>
          String(e.user_id) === String(sellerID) &&
          (block === "cool"
            ? e.mediType === "Cool chain"
            : e.mediType !== "Cool chain"),
      );
      if (!lines.length) return [];

      const withSeller = lines.find((l) => l.sellerCampaign);
      const withPlatform = lines.find((l) => l.platformCampaign);
      const sellerCampaign = withSeller ? withSeller.sellerCampaign : null;
      const platformCampaign = withPlatform
        ? withPlatform.platformCampaign
        : null;
      if (!sellerCampaign && !platformCampaign) return [];

      const exGst = lines.reduce((s, l) => s + (Number(l.price) || 0), 0);

      // tier 2: gate AND pay basis are both the gross ex-GST goods value. The product coupon is a
      // post-tax deduction now - it never touches the taxable value - so it is NOT netted off here.
      // Subtracting an incl-GST coupon from an ex-GST base would understate the goods value the
      // percentage is charged on, and would disagree with the API. Mirrors applyCouponsToOrder.
      const sellerOfferObj = offerFor(sellerCampaign, exGst, exGst, "seller");

      // tier 3: same gross gate AND the same gross pay basis. The seller cashback is NOT netted off
      // - since §4g it is a post-delivery MediWallet credit, so it reduces neither what the buyer
      // pays nor the goods value, and there is nothing for it to take out of Medimny's base. A 3%
      // platform campaign therefore pays 3% of the order, whether or not this seller is also running
      // one. Mirrors applyCouponsToOrder.
      const platformOfferObj = offerFor(
        platformCampaign,
        exGst,
        exGst,
        "platform",
      );

      // Every reward (cashback / cashbackAtMov / mov / shortfall) stays EX-GST - that is the basis
      // the tiers and their minimum order values are assessed on, and the basis shown to the buyer.
      // Neither cashback reduces this payable (both are MediWallet credits on delivery), so there is
      // no grossing-up factor to carry any more.
      return [sellerOfferObj, platformOfferObj].filter(Boolean);
    };

    /*
    The claimable vouchers on this cart - and, separately, what the auto-applied tiers are worth.

    ONLY product-level coupons and gifts are shown in the Applicable Vouchers modal and claimed by
    the buyer. Seller-tier and platform-tier rewards (cashback AND store-wide gifts) are NOT listed
    and NOT claimed: they apply automatically at checkout on any order/block that clears the tier's
    minimum order value. So `voucherGroups` (the modal) carries product rows only, while the value
    tiers are folded straight into `tierSavings` for the summary and the auto-apply-at-checkout path.

    Product coupons/gifts carry no minimum, so they are always applicable. The value tiers are still
    assessed per CHECKOUT BLOCK (one seller, cool-chain split from the rest, since that is what
    becomes one order and what the minimum is measured against); a buyer short of a minimum is told
    by the value-tier banner on the checkout block, not by this modal.
    */
    const blocks = [];
    totalItemsInCart.forEach((l) => {
      const block = l.mediType === "Cool chain" ? "cool" : "other";
      if (
        !blocks.find(
          (b) => String(b.user_id) === String(l.user_id) && b.block === block,
        )
      ) {
        blocks.push({ user_id: l.user_id, block, seller_name: l.seller_name });
      }
    });

    const groupMap = new Map();
    // Keyed by the seller's user_id so each seller's card can open a modal scoped to exactly its own
    // product coupons/gifts; sellerName is carried alongside for the modal heading.
    const pushRow = (sellerUserId, sellerName, row) => {
      if (!groupMap.has(sellerUserId))
        groupMap.set(sellerUserId, {
          sellerId: sellerUserId,
          sellerName,
          rows: [],
        });
      groupMap.get(sellerUserId).rows.push(row);
    };

    (cartDetails && cartDetails.detail ? cartDetails.detail : []).forEach(
      (line) => {
        const c = line.activeCoupon;
        if (!c) return;
        const seller = line.Seller.company_name;
        const sellerUserId = line.Inventory && line.Inventory.user_id;
        const qty =
          Number(line.cart_details && line.cart_details.quantity) || 0;
        const name = line.Inventory.product_id.name;
        const lots = couponLots(
          qty,
          line.Inventory && line.Inventory.min_order_quantity,
        );
        // A gift row names what the gift IS and what it is worth, not just that one exists: the
        // buyer is deciding whether the voucher is worth anything to them, and "Free gift with X"
        // answers neither question. Same phrasing as the value-tier banners (giftReward below) and
        // the cart line itself, and each part drops out silently when the campaign did not record
        // it - a campaign with no description still reads "Free gift with <product>".
        const gift = c.gift || {};
        const giftName = gift.description ? `${gift.description} free with` : "Free gift with";
        const giftBrand = gift.brand ? ` by ${gift.brand}` : "";
        const giftWorth =
          Number(gift.price) > 0 ? ` worth ₹${inr(gift.price)}` : "";
        pushRow(sellerUserId, seller, {
          key: `product-${line.Inventory._id}`,
          // Which of the seller's checkout blocks this voucher rides in - cool chain ships as its
          // own order, everything else together. Checking out one block claims only its own rows,
          // so the row has to know which block it is in. Same split as `lineBlock` above and as the
          // `sellerId|block` keys in blockSavings.
          block:
            (line.Inventory && line.Inventory.medicineTypeName) === "Cool chain"
              ? "cool"
              : "other",
          label:
            c.type === "gift"
              ? `${giftName} ${name}${giftBrand}${giftWorth}`
              : `₹${Number(c.coupon_value) || 0} off × ${lots} ${
                  lots === 1 ? "lot" : "lots"
                } (${name})`,
          applied: true,
          shortfall: 0,
          sellerName: seller,
        });
      },
    );

    // Value tiers are auto-applied, not claimed, so nothing is pushed to the modal here - we only
    // price in what each UNLOCKED cashback is worth (a gift adds no rupees off the payable). A locked
    // tier contributes nothing until its minimum is met at checkout.
    blocks.forEach((b) => {
      sellerOffer(b.user_id, b.block).forEach((offer) => {
        // Unlocked - cashback or gift, seller-funded or Medimny's - means this block has a reward to
        // attach the moment it is checked out, whether or not any product on it carries a coupon.
        // A locked tier is not being given yet, so it makes the block no more claimable than an
        // empty one.
        if (offer.unlocked) valueTierBlockKeys.push(blockKey(b.user_id, b.block));
        // An UNLOCKED gift adds no rupees but is very much a reward - count it so the checkout can
        // say so. A locked one is not being given yet, so it is not counted.
        if (offer.unlocked && offer.isGift) {
          tierSavings.gifts += 1;
          return;
        }
        if (!offer.unlocked || offer.isGift) return;
        const isPlatform = offer.label === "platform";
        const ex = Number(offer.cashback) || 0; // ex-GST cashback for this block
        if (isPlatform) {
          tierSavings.platform += ex;
          addSellerSaving(b.user_id, "platform", ex);
          addBlockSaving(b.user_id, b.block, "platform", ex);
        } else {
          tierSavings.cashback += ex;
          addSellerSaving(b.user_id, "cashback", ex);
          addBlockSaving(b.user_id, b.block, "cashback", ex);
        }
      });
    });

    voucherGroups = Array.from(groupMap.values());

    // One group per checkout block (seller x Cool-chain/other) that carries anything to show: the
    // block's product coupons/gifts, plus its Medimny (platform) and seller value-tier offers with
    // their unlocked/locked state. Drives the per-block "Applicable Vouchers" button and modal.
    const blockLabelOf = (block) => (block === "cool" ? "Cool Chain" : "Medical & Surgical");
    voucherBlockGroups = blocks
      .map((b) => {
        const offers = sellerOffer(b.user_id, b.block); // [sellerOfferObj?, platformOfferObj?]
        const productRows = voucherGroups
          .filter((g) => String(g.sellerId) === String(b.user_id))
          .reduce((rows, g) => rows.concat(g.rows), [])
          .filter((row) => row.block === b.block);
        return {
          sellerId: b.user_id,
          sellerName: b.seller_name,
          block: b.block,
          blockLabel: blockLabelOf(b.block),
          productRows,
          platformOffer: offers.find((o) => o.label === "platform") || null,
          sellerLevelOffer: offers.find((o) => o.label === "seller") || null,
        };
      })
      // Keep only blocks that actually carry something to show in the modal.
      .filter(
        (g) => g.productRows.length > 0 || g.platformOffer || g.sellerLevelOffer,
      );
    // Product-tier gifts were counted with the coupons above; the value tiers added theirs just now.
    tierSavings.gifts += cartGiftCount;
    tierSavings.coupons = r2(cartCouponSaving);
    tierSavings.cashback = r2(tierSavings.cashback);
    tierSavings.platform = r2(tierSavings.platform);
    // Drives the "is there any deal on this cart?" checks. Only `coupons` reduces the payable; the
    // two cashbacks are MediWallet credits on delivery, so they count as savings but not as a cut to
    // what is paid now.
    tierSavings.total = r2(
      tierSavings.coupons + tierSavings.cashback + tierSavings.platform,
    );

    isCoolChain = totalItemsInCart.filter((e) => e.mediType === "Cool chain");
    prepaidInvenAll = totalItemsInCart.filter(
      (e) => e.prepaidInven === true || e.isBulk === true,
    );
    var holder = {};
    totalItemsInCart.forEach(function (d) {
      if (holder.hasOwnProperty(d.seller_name)) {
        holder[d.seller_name] = holder[d.seller_name] + d.price;
      } else {
        holder[d.seller_name] = d.price;
      }
    });
    isPrepaid = totalItemsInCart.filter((e) => e.isPrepaid === true);

    var deliveryCal = [];

    for (var prop in holder) {
      deliveryCal.push({ seller_name: prop, price: holder[prop] });
    }

    totalItemsInCart.map((each) => {
      let filteredArray = totalItemsInCart.filter(
        (eC) => eC.user_id === each.user_id,
      );
      let sum = filteredArray.reduce((acc, current) => acc + current.price, 0);
      let gst2 = filteredArray.reduce(
        (acc, current) => acc + current.gstValue,
        0,
      );
      // This seller's share of the cart's liquid surcharge, totalled exactly the way its GST is.
      let liquidSurcharge2 = filteredArray.reduce(
        (acc, current) => acc + (current.liquidSurchargeValue || 0),
        0,
      );

      let genericC = totalItemsInCart.filter(
        (eC) =>
          eC.user_id === each.user_id &&
          (eC.mediType === "Generic" ||
            eC.mediType === "OTC" ||
            eC.mediType === "Surgical"),
      );
      let coolChainC = totalItemsInCart.filter(
        (eC) => eC.user_id === each.user_id && eC.mediType === "Cool chain",
      );
      let ethicalC = totalItemsInCart.filter(
        (eC) =>
          eC.user_id === each.user_id &&
          (eC.mediType === "Ethical branded" ||
            eC.mediType === "Others" ||
            eC.mediType === "Generic" ||
            eC.mediType === "OTC" ||
            eC.mediType === "Surgical"),
      );

      // let genericP = genericC.reduce((accumulator, currentValue) => accumulator + currentValue.price, 0);
      let coolChainP = coolChainC.reduce(
        (accumulator, currentValue) => accumulator + currentValue.price,
        0,
      );
      let ethicalP = ethicalC.reduce(
        (accumulator, currentValue) => accumulator + currentValue.price,
        0,
      );

      // let genericGst = genericC.reduce((accumulator, currentValue) => accumulator + currentValue.gstValue, 0);
      let coolChainGst = coolChainC.reduce(
        (accumulator, currentValue) => accumulator + currentValue.gstValue,
        0,
      );
      let ethicalGst = ethicalC.reduce(
        (accumulator, currentValue) => accumulator + currentValue.gstValue,
        0,
      );
      // The same two splits for the liquid surcharge. The medicine-type checkout block prices one
      // block at a time, so it needs the surcharge split the way the GST above already is - a
      // cart-wide total would over-charge whichever block the buyer checks out first.
      let coolChainLiquidSurcharge = coolChainC.reduce(
        (accumulator, currentValue) =>
          accumulator + (currentValue.liquidSurchargeValue || 0),
        0,
      );
      let ethicalLiquidSurcharge = ethicalC.reduce(
        (accumulator, currentValue) =>
          accumulator + (currentValue.liquidSurchargeValue || 0),
        0,
      );
      let prepaid = totalItemsInCart.filter(
        (e) => e.user_id === each.user_id && e.isPrepaid === true,
      );
      let prepaidInven = totalItemsInCart.filter(
        (e) =>
          e.user_id === each.user_id &&
          (e.prepaidInven === true || e.isBulk === true),
      );
      let obj = {};
      obj.user_id = each.user_id;
      obj.seller_name = each.seller_name;
      obj.price = sum;
      obj.gst1 = gst2;
      obj.liquidSurcharge = liquidSurcharge2;
      // obj.generic = genericP;
      obj.coolChain = coolChainP;
      obj.ethical = ethicalP;
      // obj.genericGst = genericGst;
      obj.coolChainGst = coolChainGst;
      obj.ethicalGst = ethicalGst;
      obj.coolChainLiquidSurcharge = coolChainLiquidSurcharge;
      obj.ethicalLiquidSurcharge = ethicalLiquidSurcharge;
      obj.prepaid = prepaid.length;
      obj.prepaidInven = prepaidInven.length;

      if (obj.price < 2000) {
        removeInventoryLists.push(each.inventory_id);
      }
      if (sellerDetails.length === 0) {
        sellerDetails.push(obj);
      } else {
        let index = sellerDetails.findIndex((e) => e.user_id === each.user_id);
        if (index === -1) {
          sellerDetails.push(obj);
        }
      }
    });
  }

  let deliveryTotal = [];
  let totalDeliChrgInCart = 0;
  // let disableCOD = false;
  // setShowCodOption(false) //for delivery range orders only
  sellerDetails.map((data, index) => {
    if (users.isDeliveryCharge === true) {
      deliveryTotal.push(Number(globalDeliveryCrg?.value));
    }
    if (
      data.ethical &&
      data.ethical > 0 &&
      deliveryMinRange?.value <= data.ethical &&
      data.ethical < deliveryMaxRange?.value
    ) {
      totalDeliChrgInCart =
        totalDeliChrgInCart + Number(newGlobalDeliveryCrg?.value);
      disableCOD = true;
    }
    if (
      data.coolChain &&
      data.coolChain > 0 &&
      deliveryMinRange?.value <= data.coolChain &&
      data.coolChain < deliveryMaxRange?.value
    ) {
      totalDeliChrgInCart =
        totalDeliChrgInCart + Number(newGlobalDeliveryCrg?.value);
      disableCOD = true;
    }
    if (users.isDeliveryCharge === true) {
      if (
        data.ethical &&
        data.ethical > 0 &&
        !(
          deliveryMinRange?.value <= data.ethical &&
          data.ethical < deliveryMaxRange?.value
        )
      ) {
        totalDeliChrgInCart =
          totalDeliChrgInCart + Number(globalDeliveryCrg.value);
      }
      if (
        data.coolChain &&
        data.coolChain > 0 &&
        !(
          deliveryMinRange?.value <= data.coolChain &&
          data.coolChain < deliveryMaxRange?.value
        )
      ) {
        totalDeliChrgInCart =
          totalDeliChrgInCart + Number(globalDeliveryCrg.value);
      }
    }
  });
  // if(disableCOD){
  //   setShowCodOption(false);
  // } else {
  //   setShowCodOption(true);
  // }
  let minOrderErrorArray = [];
  let noMinOrderErrorArray = [];

  sellerDetails.map((data) => {
    if (data.price < 2000) {
      minOrderErrorArray.push({ price: data.price, Id: data.user_id });
    } else if (data.price > 2000) {
      noMinOrderErrorArray.push(data.price);
    }
  });

  let sellerId = [];
  sellerDetails.map((data2, index) => {
    sellerId.push({
      ID: data2.user_id,
      name: data2.seller_name,
      price: data2.price,
      gst: data2.gst1,
      liquidSurcharge: data2.liquidSurcharge || 0,
      ethical: data2.ethical,
      coolChain: data2.coolChain,
      PrpaymentCod:
        Math.ceil(
          ((data2.ethical + data2.ethicalGst) *
            ((users.codPrepayPer ? users.codPrepayPer : 0) / 100)) /
            100,
        ) * 100,
      // generic: data2.generic,
      ethicalGst: data2.ethicalGst,
      coolChainGst: data2.coolChainGst,
      ethicalLiquidSurcharge: data2.ethicalLiquidSurcharge || 0,
      coolChainLiquidSurcharge: data2.coolChainLiquidSurcharge || 0,
      // genericGst: data2.genericGst,
      prepaid: data2.prepaid,
      prepaidInven: data2.prepaidInven,
    });
  });
  sellerId.sort((a, b) => a.name.localeCompare(b.name));

  let showGlobalBnpl = sellerId.filter(
    (e) =>
      (e.coolChain > 0 && e.coolChain < 5000) ||
      (e.ethical > 0 && e.ethical < 5000) ||
      (e.generic > 0 && e.generic < 5000),
  );

  return (
    <BuyerContainer>
      <div className="app-wrapper">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            {/* Full-width white card holding the Shopping Cart header. The Applicable Vouchers button
                now lives on each seller's checkout card (top-right) instead of here, so it opens a
                modal scoped to that seller's own product coupons/gifts. */}

            <ContainerHeader match={props.match} title="Shopping Cart" />
          </div>
          <div className=" col-xl-9 col-lg-9 col-md-8 col-sm-8">
            {users ? <DeliveryAddress userDataFromParent={users} /> : <br />}
            {/* Medimny's site-wide campaign sits between the address and the seller blocks: it is
                not any one seller's offer, so it must not read as belonging to the block below it.
                Renders nothing when no platform campaign is running. */}
            {platformOfferCard()}
            {/* Directly under it, in the same card shape: when the cashbacks on this cart - Medimny's
                and the seller's alike - actually reach the buyer. */}
            {cashbackWalletNoteCard()}
            {sellerId.map((eachId, index) => {
              let prePay = 0;
              let cardTotalAmount = 0;
              let ethicalCardTotal = 0;
              one = data.filter((val) => val.sellerID === eachId.ID);
              let ethical = one.filter(
                (e) =>
                  e.inventory.medicineTypeName === "Ethical branded" ||
                  e.inventory.medicineTypeName === "Others" ||
                  e.inventory.medicineTypeName === "Generic" ||
                  e.inventory.medicineTypeName === "OTC" ||
                  e.inventory.medicineTypeName === "Surgical",
              );
              let coolChain = one.filter(
                (e) => e.inventory.medicineTypeName === "Cool chain",
              );
              // let generic = one.filter(e => (e.inventory.medicineTypeName === 'Generic' || e.inventory.medicineTypeName === 'OTC' || e.inventory.medicineTypeName === 'Surgical'));
              ethical &&
                ethical.map((data, index) => {
                  if (
                    data.inventory.isDeleted === false &&
                    data.inventory.isHidden === false &&
                    data.sellerStatus === "active" &&
                    data.sellerVac === false
                  ) {
                    let singleItemTotalPrice1 =
                      data.discount.name === "Same" ||
                      data.discount.name === "SameAndDiscount"
                        ? ((data.quantity /
                            data.discount.discount_on_product.purchase) *
                            data.discount.discount_on_product.bonus +
                            data.quantity) *
                          data.inventory.ePTR
                        : data.inventory.ePTR * data.quantity;
                    GST =
                      (data.inventory.ePTR / 100) * Number(data.gstPercentage);
                    singleItemTotalGST =
                      data.discount.name === "Same" ||
                      data.discount.name === "SameAndDiscount"
                        ? ((data.quantity /
                            data.discount.discount_on_product.purchase) *
                            data.discount.discount_on_product.bonus +
                            data.quantity) *
                          GST
                        : GST * data.quantity;
                    ethicalCardTotal += singleItemTotalPrice1;
                  }
                });
              return (
                <div className="jr-card">
                  <div className="animated slideInUpTiny animation-duration-3">
                    <div className="row">
                      <div className=" col-xl-8 col-lg-8 col-md-8 col-sm-8">
                        <NavLink
                          className="buyerRedirectNavlink"
                          to={`/view-seller/${one[0].sellerID}`}
                        >
                          <h3>
                            {one[0].seller_id} ({one.length}{" "}
                            {one.length === 1 ? "item" : "items"})<br />
                            <span
                              className={
                                activeButton(eachId) ? "more2000" : "less2000"
                              }
                            >
                              ₹{eachId.price.toFixed(2)}
                            </span>
                            &nbsp;
                            <span style={{ fontSize: "smaller" }}>
                              *excluding GST
                            </span>
                          </h3>
                        </NavLink>
                      </div>
                      {activeButton(eachId) ? (
                        <div
                          className=" col-xl-4 col-lg-4 col-md-4 col-sm-4"
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: "8px",
                            flexWrap: "wrap",
                          }}
                        >
                          <button
                            style={{
                              padding: "10px",
                              backgroundColor: "#072791",
                              color: "white",
                              borderRadius: "5px",
                              whiteSpace: "nowrap",
                              border: "none",
                            }}
                            key={index}
                            onClick={(e) => individualCheckout(eachId, e)}
                          >
                            Seller CheckOut
                          </button>
                        </div>
                      ) : (
                        <div
                          className=" col-xl-4 col-lg-4 col-md-4 col-sm-4"
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: "8px",
                            flexWrap: "wrap",
                          }}
                        >
                          <button
                            style={{
                              padding: "10px",
                              backgroundColor: "#dfdfdf",
                              color: "black",
                              whiteSpace: "nowrap",
                              borderRadius: "5px",
                              border: "none",
                              cursor: "default",
                            }}
                            key={index}
                          >
                            Seller CheckOut
                          </button>
                        </div>
                      )}
                    </div>
                    {console.log("ethicalCardTotal", ethicalCardTotal)}
                    {ethicalCardTotal < (deliveryMaxRange?.value || 4500) ? (
                      <div className="font-weight-bold h3 text-maroon">
                        Orders below ₹
                        {deliveryMaxRange?.value
                          ? deliveryMaxRange?.value.toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : 4500}{" "}
                        will carry delivery charge of ₹
                        {newGlobalDeliveryCrg?.value || 49}{" "}
                      </div>
                    ) : null}
                    <hr />
                    {coolChain.length > 0 && (
                      <React.Fragment>
                        <div style={borderCoolChain}>
                          <div className="row">
                            <div className=" col-xl-8 col-lg-8 col-md-8 col-sm-8">
                              <h3 className="ml-3" style={fontS}>
                                Cool Chain &nbsp;
                                {short("coolChain", eachId) && (
                                  <span
                                    className="less2000"
                                    style={{ fontWeight: "initial" }}
                                  >
                                    (Short of ₹
                                    {(
                                      (coolChainData &&
                                        coolChainData.minOrder) -
                                      eachId.coolChain
                                    ).toLocaleString("en-IN", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                    )
                                  </span>
                                )}
                              </h3>
                            </div>
                            <div
                              className=" col-xl-4 col-lg-4 col-md-4 col-sm-4"
                              style={{ textAlign: "end" }}
                            >
                              {/* This order's offers (Cool chain block): opens the Applicable
                                  Vouchers modal scoped to this block, sitting before its CheckOut. */}
                              {voucherBlockGroups.some(
                                (g) =>
                                  String(g.sellerId) === String(eachId.ID) &&
                                  g.block === "cool",
                              ) && (
                                <button
                                  className="mr-3"
                                  style={{
                                    padding: "10px",
                                    backgroundColor: "#072791",
                                    color: "white",
                                    borderRadius: "5px",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    openVouchersModal(eachId.ID, "cool")
                                  }
                                >
                                  Applicable Voucher
                                </button>
                              )}
                              {eachId.coolChain >=
                              (coolChainData && coolChainData.minOrder) ? (
                                <button
                                  className="mr-3"
                                  style={{
                                    padding: "10px",
                                    backgroundColor: "#072791",
                                    color: "white",
                                    borderRadius: "5px",
                                    border: "none",
                                  }}
                                  key={index}
                                  onClick={(e) =>
                                    medicineFunction(eachId, "cool", coolChain, e)
                                  }
                                >
                                  CheckOut
                                </button>
                              ) : (
                                <button
                                  className="mr-3"
                                  style={{
                                    padding: "10px",
                                    backgroundColor: "#dfdfdf",
                                    color: "black",
                                    borderRadius: "5px",
                                    border: "none",
                                    cursor: "default",
                                  }}
                                  key={index}
                                >
                                  CheckOut
                                </button>
                              )}
                            </div>
                          </div>
                          {/* Seller/platform cashback + gift value-tier banners: the "add ₹X more"
                                MOV hint (locked) or "unlocked - applied automatically at order"
                                (unlocked). Shown as soon as the buyer opens the cart - these tiers
                                auto-apply at checkout, so the buyer sees how close they are to each
                                threshold without needing to claim anything. */}
                          {offerBanner(sellerOffer(eachId.ID, "cool"))}
                          {coolChain &&
                            coolChain.map((data, index) => {
                              let expDateC = new Date(
                                moment(data.inventory.expiry_date),
                              ).getTime();
                              if (
                                data.inventory.isDeleted === false &&
                                data.inventory.isHidden === false &&
                                data.sellerStatus === "active" &&
                                data.sellerVac === false
                              ) {
                                singleItemTotalPrice =
                                  data.discount.name === "Same" ||
                                  data.discount.name === "SameAndDiscount"
                                    ? ((data.quantity /
                                        data.discount.discount_on_product
                                          .purchase) *
                                        data.discount.discount_on_product
                                          .bonus +
                                        data.quantity) *
                                      data.inventory.ePTR
                                    : data.inventory.ePTR * data.quantity; //data.price * data.quantity
                                GST =
                                  (data.inventory.ePTR / 100) *
                                  Number(data.gstPercentage);
                                singleItemTotalGST =
                                  data.discount.name === "Same" ||
                                  data.discount.name === "SameAndDiscount"
                                    ? ((data.quantity /
                                        data.discount.discount_on_product
                                          .purchase) *
                                        data.discount.discount_on_product
                                          .bonus +
                                        data.quantity) *
                                      GST
                                    : GST * data.quantity;
                                AllItemsTotalPrice =
                                  AllItemsTotalPrice + singleItemTotalPrice;
                                AllItemsTotalGST =
                                  AllItemsTotalGST + singleItemTotalGST;
                                // On `singleItemTotalPrice` - the EX-GST line value, bonus units
                                // included - which is the same base GST is charged on and the same
                                // figure the API uses at placement.
                                AllItemsLiquidSurcharge =
                                  AllItemsLiquidSurcharge +
                                  liquidSurchargeForLine(
                                    data.liquidSurchargePercentage,
                                    singleItemTotalPrice,
                                  );
                                if (
                                  data.discount &&
                                  data.discount.type === "Discount"
                                ) {
                                  discountMinus =
                                    (singleItemTotalPrice / 100) *
                                    data.discount.discount_per;
                                  priceAfterDiscount =
                                    singleItemTotalPrice - discountMinus;
                                  newGST =
                                    (priceAfterDiscount / 100) *
                                    Number(data.gstPercentage);
                                  finalGST = finalGST + newGST;
                                  totalDiscountMinus =
                                    totalDiscountMinus + discountMinus;
                                }
                                if (
                                  data.discount &&
                                  (data.discount.type === "SameAndDiscount" ||
                                    data.discount.type ===
                                      "DifferentAndDiscount")
                                ) {
                                  discountMinus =
                                    (singleItemTotalPrice / 100) *
                                    data.discount.discount_per;
                                  priceAfterDiscount =
                                    singleItemTotalPrice - discountMinus;
                                  newGST =
                                    (priceAfterDiscount / 100) *
                                    data.gstPercentage;
                                  finalGST = finalGST + newGST;
                                  totalDiscountMinus =
                                    totalDiscountMinus + discountMinus;
                                }
                                if (
                                  data.discount &&
                                  data.discount.type !== "Discount"
                                ) {
                                  finalGST = finalGST + singleItemTotalGST;
                                }
                                total = AllItemsTotalPrice + AllItemsTotalGST;
                                GlobalCodOption.push(true);
                                return (
                                  <CartItems
                                    handleRem={handleRemoveFromCart}
                                    data={data}
                                    index={index}
                                    key={index}
                                    singleItemTotalPrice={singleItemTotalPrice}
                                    GST={GST}
                                    singleItemTotalGST={singleItemTotalGST}
                                    AllItemsTotalPrice={AllItemsTotalPrice}
                                    AllItemsTotalGST={AllItemsTotalGST}
                                    priceAfterDiscount={priceAfterDiscount}
                                    newGST={newGST}
                                    discountMinus={discountMinus}
                                    color={borderCoolChain.c}
                                  />
                                );
                              }
                            })}
                        </div>
                        <hr />
                      </React.Fragment>
                    )}
                    {ethical.length > 0 && (
                      <React.Fragment>
                        <div style={borderEthical}>
                          <div className="row">
                            <div className=" col-xl-8 col-lg-8 col-md-8 col-sm-8">
                              <h3 className="ml-3" style={fontS}>
                                {"Medical and Surgical"}&nbsp;
                                {short("ethicalBranded", eachId) && (
                                  <span
                                    className="less2000"
                                    style={{ fontWeight: "initial" }}
                                  >
                                    (Short of ₹
                                    {(
                                      (ethicalData && ethicalData.minOrder) -
                                      eachId.ethical
                                    ).toLocaleString("en-IN", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                    )
                                  </span>
                                )}
                              </h3>
                            </div>
                            <div
                              className=" col-xl-4 col-lg-4 col-md-4 col-sm-4"
                              style={{ textAlign: "end" }}
                            >
                              {/* This order's offers (non-cool block): opens the Applicable
                                  Vouchers modal scoped to this block, sitting before its CheckOut. */}
                              {voucherBlockGroups.some(
                                (g) =>
                                  String(g.sellerId) === String(eachId.ID) &&
                                  g.block === "other",
                              ) && (
                                <button
                                  className="mr-3"
                                  style={{
                                    padding: "10px",
                                    backgroundColor: "#072791",
                                    color: "white",
                                    borderRadius: "5px",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    openVouchersModal(eachId.ID, "other")
                                  }
                                >
                                  Applicable Voucher
                                </button>
                              )}
                              {eachId.ethical >=
                              (ethicalData && ethicalData.minOrder) ? (
                                <button
                                  className="mr-3"
                                  style={{
                                    padding: "10px",
                                    backgroundColor: "#072791",
                                    color: "white",
                                    borderRadius: "5px",
                                    border: "none",
                                  }}
                                  key={index}
                                  onClick={(e) =>
                                    medicineFunction(eachId, "ethical", ethical, e)
                                  }
                                >
                                  CheckOut
                                </button>
                              ) : (
                                <button
                                  className="mr-3"
                                  style={{
                                    padding: "10px",
                                    backgroundColor: "#dfdfdf",
                                    color: "black",
                                    borderRadius: "5px",
                                    border: "none",
                                    cursor: "default",
                                  }}
                                  key={index}
                                >
                                  CheckOut
                                </button>
                              )}
                            </div>
                          </div>
                          {/* Same as the cool-chain block: value-tier banners shown on cart open. */}
                          {offerBanner(sellerOffer(eachId.ID, "ethical"))}
                          {ethical &&
                            ethical.map((data, index) => {
                              let expDateE = new Date(
                                moment(data.inventory.expiry_date),
                              ).getTime();
                              if (
                                data.inventory.isDeleted === false &&
                                data.inventory.isHidden === false &&
                                data.sellerStatus === "active" &&
                                data.sellerVac === false
                              ) {
                                singleItemTotalPrice =
                                  data.discount.name === "Same" ||
                                  data.discount.name === "SameAndDiscount"
                                    ? ((data.quantity /
                                        data.discount.discount_on_product
                                          .purchase) *
                                        data.discount.discount_on_product
                                          .bonus +
                                        data.quantity) *
                                      data.inventory.ePTR
                                    : data.inventory.ePTR * data.quantity;
                                GST =
                                  (data.inventory.ePTR / 100) *
                                  Number(data.gstPercentage);
                                singleItemTotalGST =
                                  data.discount.name === "Same" ||
                                  data.discount.name === "SameAndDiscount"
                                    ? ((data.quantity /
                                        data.discount.discount_on_product
                                          .purchase) *
                                        data.discount.discount_on_product
                                          .bonus +
                                        data.quantity) *
                                      GST
                                    : GST * data.quantity;
                                AllItemsTotalPrice =
                                  AllItemsTotalPrice + singleItemTotalPrice;
                                AllItemsTotalGST =
                                  AllItemsTotalGST + singleItemTotalGST;
                                // On `singleItemTotalPrice` - the EX-GST line value, bonus units
                                // included - which is the same base GST is charged on and the same
                                // figure the API uses at placement.
                                AllItemsLiquidSurcharge =
                                  AllItemsLiquidSurcharge +
                                  liquidSurchargeForLine(
                                    data.liquidSurchargePercentage,
                                    singleItemTotalPrice,
                                  );
                                if (
                                  data.discount &&
                                  data.discount.type === "Discount"
                                ) {
                                  discountMinus =
                                    (singleItemTotalPrice / 100) *
                                    data.discount.discount_per;
                                  priceAfterDiscount =
                                    singleItemTotalPrice - discountMinus;
                                  newGST =
                                    (priceAfterDiscount / 100) *
                                    Number(data.gstPercentage);
                                  finalGST = finalGST + newGST;
                                  totalDiscountMinus =
                                    totalDiscountMinus + discountMinus;
                                }
                                if (
                                  data.discount &&
                                  (data.discount.type === "SameAndDiscount" ||
                                    data.discount.type ===
                                      "DifferentAndDiscount")
                                ) {
                                  discountMinus =
                                    (singleItemTotalPrice / 100) *
                                    data.discount.discount_per;
                                  priceAfterDiscount =
                                    singleItemTotalPrice - discountMinus;
                                  newGST =
                                    (priceAfterDiscount / 100) *
                                    data.gstPercentage;
                                  finalGST = finalGST + newGST;
                                  totalDiscountMinus =
                                    totalDiscountMinus + discountMinus;
                                }
                                if (
                                  data.discount &&
                                  data.discount.type !== "Discount"
                                ) {
                                  finalGST = finalGST + singleItemTotalGST;
                                }
                                total = AllItemsTotalPrice + AllItemsTotalGST;
                                prePay +=
                                  singleItemTotalPrice + singleItemTotalGST;
                                cardTotalAmount += singleItemTotalPrice;

                                if (index == ethical.length - 1) {
                                  const percentage = users?.codPrepayPer || 0;
                                  PrtialCod += Math.max(
                                    500,
                                    Math.ceil(
                                      (prePay * (percentage / 100)) / 100,
                                    ) * 100,
                                  );
                                  if (
                                    cardTotalAmount < deliveryMaxRange?.value
                                  ) {
                                    GlobalCodOption.push(true);
                                  }
                                }
                                return (
                                  <CartItems
                                    handleRem={handleRemoveFromCart}
                                    data={data}
                                    index={index}
                                    key={index}
                                    singleItemTotalPrice={singleItemTotalPrice}
                                    GST={GST}
                                    singleItemTotalGST={singleItemTotalGST}
                                    AllItemsTotalPrice={AllItemsTotalPrice}
                                    AllItemsTotalGST={AllItemsTotalGST}
                                    priceAfterDiscount={priceAfterDiscount}
                                    newGST={newGST}
                                    discountMinus={discountMinus}
                                    color={borderEthical.c}
                                  />
                                );
                              }
                            })}
                        </div>
                        <hr />
                      </React.Fragment>
                    )}
                    {/* {generic.length > 0 &&
                        <React.Fragment>
                          <div style={borderGeneric} >
                            <div className="row">
                              <div className=" col-xl-8 col-lg-8 col-md-8 col-sm-8">
                                <h3 className='ml-3' style={fontS}>{'Generic & Surgical'}&nbsp;
                                  {short('generic', eachId) &&
                                    <span className='less2000' style={{ fontWeight: 'initial' }}>(Short of ₹{((genericData && genericData.minOrder) - eachId.generic).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })})</span>}
                                </h3>
                              </div>
                              {eachId.generic >= (genericData && genericData.minOrder) ?
                                <div className=" col-xl-4 col-lg-4 col-md-4 col-sm-4" style={{ textAlign: "end" }}>
                                  <button className='mr-3' style={{ padding: '10px', backgroundColor: '#072791', color: 'white', borderRadius: '5px', border: 'none' }} key={index}
                                    onClick={(e) => medicineFunction(eachId, 'generic', generic, e)}>CheckOut
                                  </button>
                                </div> :
                                <div className=" col-xl-4 col-lg-4 col-md-4 col-sm-4" style={{ textAlign: "end" }}>
                                  <button className='mr-3' style={{ padding: '10px', backgroundColor: '#dfdfdf', color: 'black', borderRadius: '5px', border: 'none', cursor: 'default' }} key={index}>CheckOut
                                  </button>
                                </div>
                              }
                            </div>
                            {generic && generic.map((data, index) => {
                              let expDateG = new Date(moment(data.inventory.expiry_date)).getTime();
                              if (data.inventory.isDeleted === false && data.inventory.isHidden === false && data.sellerStatus === 'active' && data.sellerVac === false) {
                                singleItemTotalPrice = (data.discount.name === 'Same' || data.discount.name === 'SameAndDiscount') ? ((data.quantity / data.discount.discount_on_product.purchase * (data.discount.discount_on_product.bonus) + data.quantity) * data.inventory.ePTR) : data.inventory.ePTR * data.quantity
                                GST = data.inventory.ePTR / 100 * Number(data.gstPercentage)
                                singleItemTotalGST = (data.discount.name === 'Same' || data.discount.name === 'SameAndDiscount') ? ((data.quantity / data.discount.discount_on_product.purchase * (data.discount.discount_on_product.bonus) + data.quantity)) * GST : GST * data.quantity
                                AllItemsTotalPrice = AllItemsTotalPrice + singleItemTotalPrice
                                AllItemsTotalGST = AllItemsTotalGST + singleItemTotalGST
                                // On the EX-GST line value, same base as GST - see util/liquidSurcharge.
                                AllItemsLiquidSurcharge = AllItemsLiquidSurcharge + liquidSurchargeForLine(data.liquidSurchargePercentage, singleItemTotalPrice)
                                if (data.discount && data.discount.type === 'Discount') {
                                  discountMinus = singleItemTotalPrice / 100 * data.discount.discount_per
                                  priceAfterDiscount = singleItemTotalPrice - discountMinus
                                  newGST = priceAfterDiscount / 100 * Number(data.gstPercentage)
                                  finalGST = finalGST + newGST
                                  totalDiscountMinus = totalDiscountMinus + discountMinus
                                }
                                if (data.discount && (data.discount.type === 'SameAndDiscount' || data.discount.type === 'DifferentAndDiscount')) {
                                  discountMinus = singleItemTotalPrice / 100 * data.discount.discount_per
                                  priceAfterDiscount = singleItemTotalPrice - discountMinus
                                  newGST = priceAfterDiscount / 100 * data.gstPercentage
                                  finalGST = finalGST + newGST
                                  totalDiscountMinus = totalDiscountMinus + discountMinus
                                }
                                if (data.discount && data.discount.type !== 'Discount') {
                                  finalGST = finalGST + singleItemTotalGST
                                }
                                total = AllItemsTotalPrice + AllItemsTotalGST
                                return (
                                  <CartItems
                                    handleRem={handleRemoveFromCart}
                                    data={data}
                                    index={index}
                                    key={index}
                                    singleItemTotalPrice={singleItemTotalPrice}
                                    GST={GST}
                                    singleItemTotalGST={singleItemTotalGST}
                                    AllItemsTotalPrice={AllItemsTotalPrice}
                                    AllItemsTotalGST={AllItemsTotalGST}
                                    priceAfterDiscount={priceAfterDiscount}
                                    newGST={newGST}
                                    discountMinus={discountMinus}
                                    color={borderGeneric.c}
                                  />
                                )
                              }
                            }
                            )}
                          </div><hr />
                        </React.Fragment>
                      } */}
                  </div>
                </div>
              );
            })}
          </div>
          {/* total checkout  dig*/}
          <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 mt-3">
            <div className="shadow border-0 bg-white text-black card">
              <div className="card-body">
                <h3 className="font-weight-bold ">Order Summary</h3>
                <hr />
                <table style={{ width: "100%" }}>
                  {users && (
                    <tr class="mb-1">
                      <td
                        className="h4"
                        style={{ padding: 0, justifyContent: "start" }}
                      >
                        MediWallet:
                      </td>
                      <td
                        className="h4  mt-1 mb-1"
                        style={{
                          float: "right",
                          justifyContent: "end",
                          padding: 0,
                        }}
                      >
                        MNY{" "}
                        {users.wallet_balance.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                    </tr>
                  )}
                  {/* Items Total is EX-GST. The three tier deductions sit here, ABOVE Total GST, so
                      the buyer can see that Product, Seller and Platform tiers are all assessed on the
                      ex-GST value; GST is then recomputed on what's left, so it also drops. */}
                  <tr class="mb-1">
                    <td
                      className="h4"
                      style={{ padding: 0, justifyContent: "start" }}
                    >
                      Items Total:
                    </td>
                    <td
                      className="h4  mt-1 mb-1"
                      style={{
                        float: "right",
                        justifyContent: "end",
                        padding: 0,
                      }}
                    >
                      ₹{AllItemsTotalPrice.toFixed(2)}
                    </td>
                  </tr>
                  {/* The Product Coupons deduction now sits BELOW Total GST and Delivery Charge, not
                      above them: it is a flat post-tax cut off the GST-inclusive total, so the rows
                      read as a running total down to Payable. */}
                  {/* Neither cashback is in this table any more. Both are credited to the MediWallet
                      after delivery rather than taken off what is being paid, so they now sit BELOW
                      the amount due, under the Amount to be pay row - out of the running total the
                      rows above add up to. */}
                  {/* GST is charged in full on the Items Total. NO tier reduces the taxable value any
                      more: the product coupon is a post-tax deduction off the payable below, and both
                      cashbacks are flat rewards credited to the MediWallet on delivery. */}
                  <tr class="mb-1">
                    <td
                      className="h4"
                      style={{ padding: 0, justifyContent: "start" }}
                    >
                      Total GST:
                    </td>
                    <td
                      className="h4  mt-1 mb-1"
                      style={{
                        float: "right",
                        justifyContent: "end",
                        padding: 0,
                      }}
                    >
                      ₹{AllItemsTotalGST.toFixed(2)}
                    </td>
                  </tr>
                  {totalDeliChrgInCart > 0 && (
                    <tr class="mb-1">
                      <td
                        className="h4"
                        style={{ padding: 0, justifyContent: "start" }}
                      >
                        Delivery Charge:
                      </td>
                      <td
                        className="h4  mt-1 mb-1"
                        style={{
                          float: "right",
                          justifyContent: "end",
                          padding: 0,
                        }}
                      >
                        ₹{totalDeliChrgInCart.toFixed(2)}
                      </td>
                    </tr>
                  )}
                  {/* Charged on the liquid items only, at each product's own rate, on the same
                      ex-GST value GST is charged on. Sits beside the delivery charge because it
                      behaves like one: added to the payable, and not part of the Items Total or the
                      taxable value. Hidden when the cart holds no liquid product. */}
                  {AllItemsLiquidSurcharge > 0 && (
                    <tr class="mb-1">
                      <td
                        className="h4"
                        style={{ padding: 0, justifyContent: "start" }}
                      >
                        Liquid delivery charge:
                      </td>
                      <td
                        className="h4  mt-1 mb-1"
                        style={{
                          float: "right",
                          justifyContent: "end",
                          padding: 0,
                        }}
                      >
                        ₹{AllItemsLiquidSurcharge.toFixed(2)}
                      </td>
                    </tr>
                  )}
                  {/* The product coupon, taken off the GST-INCLUSIVE total above. Its face value is
                      exactly what leaves the payable - a ₹120 coupon shows -₹120 and takes ₹120. */}
                  {tierSavings.coupons > 0 && (
                    <tr class="mb-1">
                      <td
                        className="h4 text-success"
                        style={{ padding: 0, justifyContent: "start" }}
                      >
                        Product Coupons:
                      </td>
                      <td
                        className="h4 mt-1 mb-1 text-success"
                        style={{
                          float: "right",
                          justifyContent: "end",
                          padding: 0,
                        }}
                      >
                        -₹{tierSavings.coupons.toFixed(2)}
                      </td>
                    </tr>
                  )}
                  {/* No gift row here by design. This table is what the buyer PAYS, and a gift moves
                      none of it - the cart lines above already show which items carry one, so a
                      count in the price breakdown only restates it. Gifts still have to be COUNTED
                      though (tierSavings.gifts): that is what tells a gift-only cart it has a reward
                      worth claiming at all. See hasAnyReward. */}
                  {/* Compute the amount due once, here, so Payable and every row below it agree.
                      ONLY the product coupons come off the payable, at face value. Both cashbacks are
                      credited to the buyer's MediWallet on delivery, so neither reduces what is paid
                      now. */}
                  {(() => {
                    // The liquid surcharge is added on both branches, alongside the delivery charge:
                    // it is part of what is being paid, and the product coupon comes off the total
                    // AFTER it the same way it comes off delivery.
                    payableAmount =
                      tierSavings.total > 0
                        ? Math.max(
                            0,
                            AllItemsTotalPrice +
                              AllItemsTotalGST +
                              totalDeliChrgInCart +
                              AllItemsLiquidSurcharge -
                              tierSavings.coupons,
                          )
                        : AllItemsTotalPrice +
                          AllItemsTotalGST +
                          totalDeliChrgInCart +
                          AllItemsLiquidSurcharge;
                    return null;
                  })()}
                  {tierSavings.total > 0 ? (
                    <tr class="mb-1">
                      <td
                        className="h4 font-weight-bold"
                        style={{ padding: 0, justifyContent: "start" }}
                      >
                        Payable:
                      </td>
                      <td
                        className="h4 mt-1 mb-1 font-weight-bold"
                        style={{
                          float: "right",
                          justifyContent: "end",
                          padding: 0,
                        }}
                      >
                        ₹
                        {payableAmount.toLocaleString("en-IN", {
                          maximumFractionDigits: 2,
                        })}
                      </td>
                    </tr>
                  ) : (
                    <tr class="mb-1">
                      <td
                        className="h4"
                        style={{ padding: 0, justifyContent: "start" }}
                      >
                        Invoice Total:
                      </td>
                      <td
                        className="h4  mt-1 mb-1"
                        style={{
                          float: "right",
                          justifyContent: "end",
                          padding: 0,
                        }}
                      >
                        ₹
                        {payableAmount.toLocaleString("en-IN", {
                          maximumFractionDigits: 2,
                        })}
                      </td>
                    </tr>
                  )}
                  {isCodPrepayValid && selectedValue === "Partial" ? (
                    <tr height="25px">
                      <td
                        className="h4"
                        style={{ padding: 0, justifyContent: "start" }}
                      >
                        Prepay Amount:
                      </td>
                      <td
                        className="h4  mt-1 mb-1"
                        style={{
                          float: "right",
                          justifyContent: "end",
                          padding: 0,
                        }}
                      >
                        {
                          <React.Fragment>
                            ₹{Number(PrtialCod).toFixed(2)}
                          </React.Fragment>
                        }
                      </td>
                    </tr>
                  ) : (
                    ""
                  )}
                  {users.wallet_balance > 0 && selectedValue === "Online" ? (
                    <tr class="mb-1">
                      <td
                        className="h4 text-success"
                        style={{ padding: 0, justifyContent: "start" }}
                      >
                        MediWallet:
                      </td>
                      <td
                        className="h3  mt-1 text-success"
                        style={{
                          float: "right",
                          justifyContent: "end",
                          padding: 0,
                        }}
                      >
                        {Number(payableAmount) >
                        Number(users && users.wallet_balance) ? (
                          <React.Fragment>
                            -₹{Number(users && users.wallet_balance).toFixed(2)}
                          </React.Fragment>
                        ) : Number(users && users.wallet_balance) === 0 ? (
                          <React.Fragment>₹{0}</React.Fragment>
                        ) : (
                          <React.Fragment>
                            -₹{Number(payableAmount).toFixed(2)}
                          </React.Fragment>
                        )}
                      </td>
                    </tr>
                  ) : users.wallet_balance < 0 && selectedValue === "Online" ? (
                    <tr height="25px">
                      <td
                        className="h4 text-success"
                        style={{ padding: 0, justifyContent: "start" }}
                      >
                        MediWallet:
                      </td>
                      <td
                        className="h3  mt-2 text-success"
                        style={{ textAlign: "end", padding: 0 }}
                      >
                        <React.Fragment>
                          +₹{Math.abs(users && users.wallet_balance).toFixed(2)}
                        </React.Fragment>
                      </td>
                    </tr>
                  ) : null}
                  {users.wallet_balance > 0 && selectedValue === "Partial" ? (
                    <tr>
                      <td
                        className="h4 text-success"
                        style={{ padding: 0, justifyContent: "start" }}
                      >
                        MediWallet:
                      </td>
                      <td
                        className="h3  mt-1 text-success"
                        style={{
                          float: "right",
                          justifyContent: "end",
                          padding: 0,
                        }}
                      >
                        {Number(PrtialCod) >
                        Number(users && users.wallet_balance) ? (
                          <React.Fragment>
                            -₹{Number(users && users.wallet_balance).toFixed(2)}
                          </React.Fragment>
                        ) : Number(users && users.wallet_balance) === 0 ? (
                          <React.Fragment>₹{0}</React.Fragment>
                        ) : (
                          <React.Fragment>
                            -₹{Number(PrtialCod).toFixed(2)}
                          </React.Fragment>
                        )}
                      </td>
                    </tr>
                  ) : users.wallet_balance < 0 &&
                    selectedValue === "Partial" ? (
                    <tr height="25px">
                      <td
                        className="h4 text-success"
                        style={{ padding: 0, justifyContent: "start" }}
                      >
                        MediWallet:
                      </td>
                      <td
                        className="h3  mt-2 text-success"
                        style={{ textAlign: "end", padding: 0 }}
                      >
                        <React.Fragment>
                          +₹{Math.abs(users && users.wallet_balance).toFixed(2)}
                        </React.Fragment>
                      </td>
                    </tr>
                  ) : null}
                  {/* Amount to be pay now total checkout */}
                  {isCodPrepayValid && selectedValue === "Partial" ? (
                    <tr>
                      <td
                        className="h4"
                        style={{ padding: 0, justifyContent: "start" }}
                      >
                        Amount to be pay now:
                      </td>
                      <td
                        className="h3 "
                        style={{
                          float: "right",
                          justifyContent: "end",
                          padding: 0,
                        }}
                      >
                        {Number(Number(PrtialCod) + individualDeliveryChrg) <
                        Number(users && users.wallet_balance) ? (
                          <React.Fragment>₹{0}</React.Fragment>
                        ) : (
                          <React.Fragment>
                            ₹
                            {Number(
                              Number(PrtialCod) +
                                individualDeliveryChrg -
                                Number(users && users.wallet_balance),
                            ).toFixed(2)}
                          </React.Fragment>
                        )}
                      </td>
                    </tr>
                  ) : null}
                </table>
                <hr />
                <table style={{ width: "100%" }}>
                  <tr>
                    <td className="font-weight-bold h3 text-maroon">
                      {selectedValue != "Online"
                        ? "Amount to be pay later "
                        : "Amount to be pay now"}
                      :
                    </td>
                    <td
                      className="font-weight-bold h3 text-red mt-1"
                      style={{ textAlign: "right", float: "right", padding: 0 }}
                    >
                      {(() => {
                        // Reuses the shared payableAmount set at the Payable line above, so the amount
                        // due here matches it (vouchers priced in) instead of the pre-voucher `total`.
                        // Wallet/partial come off that base.
                        const walletBal = Number(users && users.wallet_balance);
                        if (selectedValue === "Online") {
                          return (
                            <React.Fragment>
                              ₹
                              {walletBal > payableAmount
                                ? 0
                                : (payableAmount - walletBal).toLocaleString(
                                    "en-IN",
                                    { maximumFractionDigits: 2 },
                                  )}
                            </React.Fragment>
                          );
                        }
                        return (
                          <React.Fragment>
                            ₹
                            {Number(
                              payableAmount -
                                (selectedValue == "Partial"
                                  ? Number(PrtialCod)
                                  : 0),
                            ).toLocaleString("en-IN", {
                              maximumFractionDigits: 2,
                            })}
                          </React.Fragment>
                        );
                      })()}
                    </td>
                  </tr>
                  {/* The cashbacks, under the amount due rather than among the rows that make it up.
                      Neither one reduces what is paid - both are credited to the MediWallet after
                      delivery (the card above the seller blocks says when) - so sitting below the
                      figure the buyer is paying is the one place they cannot be read as part of it. */}
                  {tierSavings.cashback > 0 && (
                    <tr>
                      <td
                        className="h4 text-success"
                        style={{ padding: 0, justifyContent: "start" }}
                      >
                        Seller Cashback :
                      </td>
                      <td
                        className="h4 mt-1 mb-1 text-success"
                        style={{
                          float: "right",
                          justifyContent: "end",
                          padding: 0,
                        }}
                      >
                        ₹{tierSavings.cashback.toFixed(2)}
                      </td>
                    </tr>
                  )}
                  {tierSavings.platform > 0 && (
                    <tr>
                      <td
                        className="h4 text-success"
                        style={{ padding: 0, justifyContent: "start" }}
                      >
                        Medimny Cashback :
                      </td>
                      <td
                        className="h4 mt-1 mb-1 text-success"
                        style={{
                          float: "right",
                          justifyContent: "end",
                          padding: 0,
                        }}
                      >
                        ₹{tierSavings.platform.toFixed(2)}
                      </td>
                    </tr>
                  )}
                </table>
                <hr />
                <h3 className="font-weight-bold ">Payment Type</h3>
                {totalDeliChrgInCart > 0 ? (
                  <Row>
                    <span className="text-sm text-gray-600 my-2">
                      <strong>Note:</strong> Order below ₹
                      {deliveryMaxRange?.value} will carry delivery charge
                      of&nbsp;
                      <strong className="text-danger">
                        ₹{newGlobalDeliveryCrg?.value.toLocaleString("en-IN")}
                      </strong>
                    </span>
                  </Row>
                ) : (
                  ""
                )}
                <hr />
                {GlobalCodOption.length == 0 &&
                users &&
                users.cod &&
                users.cod === true &&
                users.codService &&
                users.codService === true &&
                globalCod &&
                globalCod.key === "globalCod" &&
                globalCod.value === "1" &&
                isCoolChain.length === 0 &&
                isPrepaid.length < 1 &&
                prepaidInvenAll.length === 0 &&
                (totalDeliverd >= 10 ||
                  (totalOpenCOD < 5 &&
                    Math.max(
                      0,
                      total +
                        totalDeliChrgInCart +
                        AllItemsLiquidSurcharge -
                        tierSavings.coupons,
                    ) +
                      codTotalAmount <
                      35000)) ? (
                  <Row>
                    <Col md={9} xl={9} lg={9} sm={9} xs={9} className="mt-2">
                      <h4>Cash on Delivery:</h4>
                    </Col>
                    <Col md={3} xl={3} lg={3} sm={3} xs={3}>
                      <Radio
                        color="primary"
                        checked={selectedValue === "COD"}
                        onChange={handleRadioChange}
                        value="COD"
                        name="radio button demo"
                        aria-label="A"
                      />
                    </Col>
                  </Row>
                ) : (
                  ""
                )}
                {users &&
                isCodPrepayValid &&
                !isCoolChain?.length &&
                !isPrepaid?.length &&
                !prepaidInvenAll?.length ? (
                  <Row>
                    {selectedValue === "Partial" && isCodPrepayValid ? (
                      <span className="text-sm text-gray-600 my-2">
                        <strong>Note:</strong> Since you have opted for a
                        partial payment order, you will need to pay&nbsp;
                        <strong className="text-danger">
                          ₹{PrtialCod.toLocaleString("en-IN")}
                        </strong>{" "}
                        to proceed.
                      </span>
                    ) : null}
                    <Col md={9} xl={9} lg={9} sm={9} xs={9} className="mt-2">
                      <h4 className="mb-0">Partial Payment:</h4>
                    </Col>
                    <Col md={3} xl={3} lg={3} sm={3} xs={3}>
                      <Radio
                        color="primary"
                        checked={selectedValue === "Partial"}
                        onChange={handleRadioChange}
                        value="Partial"
                        name="radio button demo"
                        aria-label="A"
                      />
                    </Col>
                  </Row>
                ) : (
                  ""
                )}
                {!asAdmin ? (
                  <Row>
                    <Col md={9} xl={9} lg={9} sm={9} xs={9} className="mt-2">
                      <h4>Pay Now:</h4>
                    </Col>
                    <Col md={3} xl={3} lg={3} sm={3} xs={3}>
                      <Radio
                        color="primary"
                        checked={selectedValue === "Online"}
                        onChange={handleRadioChange}
                        value="Online"
                        name="radio button demo"
                        aria-label="B"
                      />
                    </Col>
                  </Row>
                ) : (
                  ""
                )}
                {showUpiToggle &&
                (selectedValue === "Online"
                  ? Number(users && users.wallet_balance) <
                    Number(total + totalDeliChrgInCart)
                  : Number(Number(PrtialCod)) >
                    Number(users && users.wallet_balance)) ? (
                  <>
                    <hr />
                    <h3 className="font-weight-bold ">Payment Method</h3>
                    <hr />
                    <Row>
                      <Col md={9} xl={9} lg={9} sm={9} xs={9} className="mt-2">
                        <h4>Pay with UPI:</h4>
                      </Col>
                      <Col md={3} xl={3} lg={3} sm={3} xs={3}>
                        <Radio
                          color="primary"
                          checked={upiType === "upi"}
                          onChange={upiRadioChange}
                          value="upi"
                          name="radio button demo"
                          aria-label="A"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={9} xl={9} lg={9} sm={9} xs={9} className="mt-2">
                        <h4>Credit/Debit/Other:</h4>
                      </Col>
                      <Col md={3} xl={3} lg={3} sm={3} xs={3}>
                        <Radio
                          color="primary"
                          checked={upiType === "credit"}
                          onChange={upiRadioChange}
                          value="credit"
                          name="radio button demo"
                          aria-label="A"
                        />
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}
                {showGlobalBnpl.length === 0 &&
                users.isBnpl === true &&
                globalBnpl &&
                globalBnpl.value === "1" &&
                bnplBal > Number(total + totalDeliChrgInCart) ? (
                  <Row>
                    <Col md={9} xl={9} lg={9} sm={9} xs={9} className="mt-2">
                      <span>
                        <h4 className="mb-0">BNPL :</h4>
                        <span> Available limit: </span>{" "}
                        <span style={{ color: "green" }}>
                          ₹
                          {bnplBal.toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </span>
                    </Col>
                    <Col md={3} xl={3} lg={3} sm={3} xs={3}>
                      <Radio
                        color="primary"
                        checked={selectedValue === "BNPL"}
                        onChange={handleRadioChange}
                        value="BNPL"
                        name="radio button demo"
                        aria-label="C"
                      />
                    </Col>
                  </Row>
                ) : showGlobalBnpl.length === 0 &&
                  users.isBnpl === true &&
                  globalBnpl &&
                  globalBnpl.value === "1" &&
                  bnplBal < Number(total + totalDeliChrgInCart) ? (
                  <Row>
                    <Col md={9} xl={9} lg={9} sm={9} xs={9} className="mt-2">
                      <h4 className="mb-0">BNPL :</h4>
                      <span> Available limit: </span>{" "}
                      <span style={{ color: "green" }}>
                        ₹
                        {bnplBal.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </Col>
                    <Col md={3} xl={3} lg={3} sm={3} xs={3}>
                      <Radio
                        color="primary"
                        checked={selectedValue === "BNPL"}
                        disabled={true}
                        value="BNPL"
                        name="radio button demo"
                        aria-label="C"
                      />
                    </Col>
                  </Row>
                ) : (
                  ""
                )}
                <br />
                {users &&
                cartDetails &&
                cartDetails.detail &&
                cartDetails.detail.length !== 0 &&
                selectedValue === "BNPL" &&
                showUpiToggle &&
                upiType != "" ? (
                  <button
                    style={{
                      padding: "10px",
                      width: "100%",
                      backgroundColor: "#072791",
                      color: "white",
                      borderRadius: "5px",
                      border: "none",
                    }}
                    disabled={isLoading}
                    onClick={(e) => { claimForOpenCheckout(e); setOtpModel(true); }}
                  >
                    Confirm Your Order
                  </button>
                ) : users ? (
                  cartDetails &&
                  cartDetails.detail &&
                  cartDetails.detail.length !== 0 &&
                  selectedValue === "Partial" &&
                  ((showUpiToggle && upiType != "") ||
                    Number(users && users.wallet_balance) >=
                      Number(PrtialCod)) ? (
                    <button
                      style={{
                        padding: "10px",
                        width: "100%",
                        backgroundColor: "#072791",
                        color: "white",
                        borderRadius: "5px",
                        border: "none",
                      }}
                      disabled={isLoading}
                      onClick={handleOnlineModal}
                    >
                      Confirm Your Order
                    </button>
                  ) : cartDetails &&
                    cartDetails.detail &&
                    cartDetails.detail.length !== 0 &&
                    selectedValue === "COD" ? (
                    <button
                      style={{
                        padding: "10px",
                        width: "100%",
                        backgroundColor: "#072791",
                        color: "white",
                        borderRadius: "5px",
                        border: "none",
                      }}
                      disabled={isLoading}
                      onClick={handleOnlineModal}
                    >
                      Confirm Your Order
                    </button>
                  ) : users &&
                    cartDetails &&
                    cartDetails.detail &&
                    cartDetails.detail.length !== 0 &&
                    selectedValue === "Online" &&
                    ((showUpiToggle && upiType != "") ||
                      Number(users && users.wallet_balance) >
                        Number(total + totalDeliChrgInCart)) ? (
                    <button
                      style={{
                        padding: "10px",
                        width: "100%",
                        backgroundColor: "#072791",
                        color: "white",
                        borderRadius: "5px",
                        border: "none",
                      }}
                      disabled={isLoading}
                      onClick={(e) => { claimForOpenCheckout(e); setOpenNewPopup(true); }}
                    >
                      Confirm Your Order
                    </button>
                  ) : users &&
                    cartDetails &&
                    cartDetails.detail &&
                    cartDetails.detail.length !== 0 &&
                    selectedValue === "" ? (
                    <button
                      style={{
                        padding: "10px",
                        width: "100%",
                        backgroundColor: "#dfdfdf",
                        color: "black",
                        borderRadius: "5px",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      Select Payment Method
                    </button>
                  ) : (
                    <NavLink
                      className="buyerRedirectNavlink"
                      to={{ pathname: "/", state: "/" }}
                    >
                      <button
                        style={{
                          padding: "10px",
                          width: "100%",
                          backgroundColor: "#dfdfdf",
                          color: "black",
                          borderRadius: "5px",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        {showUpiToggle &&
                        Number(users && users.wallet_balance) <
                          Number(total + totalDeliChrgInCart) &&
                        upiType == ""
                          ? "Select payment method"
                          : "Add some items"}
                      </button>
                    </NavLink>
                  )
                ) : isUserLoggedIn === null ? (
                  <NavLink
                    className="buyerRedirectNavlink"
                    to={{ pathname: "/login", state: "/MyCart" }}
                  >
                    <button
                      style={{
                        padding: "10px",
                        width: "100%",
                        backgroundColor: "#072791",
                        color: "white",
                        borderRadius: "5px",
                        border: "none",
                      }}
                    >
                      Sign In To Continue
                    </button>
                  </NavLink>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>

          <Dialog
            open={openModal === true}
            onClose={handleClose}
            fullWidth={true}
            maxWidth={"md"}
          >
            <DialogContent className="mb-1" style={{ overflow: "hidden" }}>
              <MyCartModalError errorData={errorData} />
              {!LicenseErr ? (
                <h4 className="mt-1">Do you accept the above changes?</h4>
              ) : (
                ""
              )}
            </DialogContent>
            <DialogActions className="pr-4">
              <React.Fragment>
                {!LicenseErr ? (
                  <Button onClick={handleClose} color="secondary">
                    No
                  </Button>
                ) : (
                  ""
                )}
                {LicenseErr ? (
                  <Button type="submit" color="primary" onClick={handleClose}>
                    Ok
                  </Button>
                ) : (
                  <Button type="submit" color="primary" onClick={yesShowCart}>
                    Yes, update cart
                  </Button>
                )}
              </React.Fragment>
            </DialogActions>
          </Dialog>

          <Dialog
            open={minOrderError === true}
            onClose={handleMinOrderErrorClose}
            fullWidth={true}
          >
            <DialogContent style={{ overflow: "hidden" }}>
              <DialogTitle
                className=""
                id="alert-dialog-title"
                style={{ textAlign: "center" }}
              >
                <span className="text-danger mb-3">
                  <i class="zmdi zmdi-alert-circle animated wobble zmdi-hc-5x"></i>
                </span>
              </DialogTitle>
              <h4 className="font-weight mt-3 mb-5">
                You have not crossed the minimum order price of ₹2000 for the
                following sellers:
              </h4>
              {sellerDetails.map((data) => {
                return (
                  <tr>
                    <td
                      className="h4 mt-1"
                      style={{
                        float: "left",
                        justifyContent: "end",
                        marginBottom: "0px",
                        cursor: "pointer",
                      }}
                    >
                      {data.price < 2000 ? (
                        data.discount_type === "Discount" &&
                        data.discount_per ? (
                          <React.Fragment>
                            {j++ + ". Seller Name: "}
                            <NavLink
                              className="buyerRedirectNavlink"
                              to={`/view-seller/${data.user_id}`}
                            >
                              {data && data.seller_name}
                            </NavLink>
                            {" ₹" +
                              (
                                2000 -
                                (data.price -
                                  (data.price / 100) *
                                    Number(data.discount_per))
                              ).toFixed(2) +
                              " short of ₹2000"}
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            {j++ + ". Seller Name: "}
                            <NavLink
                              className="buyerRedirectNavlink"
                              to={`/view-seller/${data.user_id}`}
                            >
                              {data && data.seller_name}
                            </NavLink>
                            {" ₹" +
                              (2000 - data.price).toFixed(2) +
                              " short of ₹2000"}
                          </React.Fragment>
                        )
                      ) : (
                        " "
                      )}
                    </td>
                  </tr>
                );
              })}
              {noMinOrderErrorArray.length < 1 ? (
                <h4 className="font-weight mt-5 mb-3">
                  Please continue shopping and add more products offered by
                  these sellers.
                </h4>
              ) : (
                <h4 className="font-weight mt-5 mb-3">
                  Please continue shopping and add more products offered by
                  these sellers, or place this order for products excluding the
                  ones offered by these sellers.
                </h4>
              )}
            </DialogContent>
            <DialogActions className="pr-4">
              <Button onClick={handleMinOrderErrorClose} color="secondary">
                Continue shopping
              </Button>
              {noMinOrderErrorArray.length < 1 ? null : (
                <Button
                  type="submit"
                  color="primary"
                  onClick={() => minOrderErrorProceed(removeInventoryLists)}
                >
                  Place Order
                </Button>
              )}
            </DialogActions>
          </Dialog>

          <Dialog
            open={minOrderErrorIndividual === true}
            onClose={handleMinOrderErrorClose}
            fullWidth={true}
          >
            <DialogContent style={{ overflow: "hidden" }}>
              <DialogTitle
                className=""
                id="alert-dialog-title"
                style={{ textAlign: "center" }}
              >
                <span className="text-danger mb-3">
                  <i class="zmdi zmdi-alert-circle animated wobble zmdi-hc-5x"></i>
                </span>
              </DialogTitle>
              <h4 className="font-weight mt-3 mb-5">
                You have not crossed the minimum order price of ₹2000 for the
                following seller:
              </h4>
              {sellerDetails.map((data) => {
                return data.user_id === individualSeller.ID ? (
                  <tr>
                    <td
                      className="h4 mt-1"
                      style={{
                        float: "left",
                        justifyContent: "end",
                        marginBottom: "0px",
                        cursor: "pointer",
                      }}
                    >
                      {data.price < 2000 ? (
                        data.discount_type === "Discount" &&
                        data.discount_per ? (
                          <React.Fragment>
                            {"Seller Name: "}
                            <NavLink
                              className="buyerRedirectNavlink"
                              to={`/view-seller/${data.user_id}`}
                            >
                              {data && data.seller_name}
                            </NavLink>
                            {" ₹" +
                              (
                                2000 -
                                (data.price -
                                  (data.price / 100) *
                                    Number(data.discount_per))
                              ).toFixed(2) +
                              " short of ₹2000"}
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            {"Seller Name: "}
                            <NavLink
                              className="buyerRedirectNavlink"
                              to={`/view-seller/${data.user_id}`}
                            >
                              {data && data.seller_name}
                            </NavLink>
                            {" ₹" +
                              (2000 - data.price).toFixed(2) +
                              " short of ₹2000"}
                          </React.Fragment>
                        )
                      ) : (
                        " "
                      )}
                    </td>
                  </tr>
                ) : (
                  ""
                );
              })}
              <h4 className="font-weight mt-5 mb-3">
                Please continue shopping and add more products offered by this
                seller.
              </h4>
            </DialogContent>
            <DialogActions className="pr-4">
              <Button onClick={handleMinOrderErrorClose} color="secondary">
                Continue shopping
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={open}
            onClose={handleOnlineModalClose}
            fullWidth={true}
            maxWidth={"sm"}
          >
            <DialogTitle className="pb-0">Checkout</DialogTitle>
            <DialogContent>
              <p
                style={{
                  marginBottom: "2px",
                  textAlign: "left",
                  fontWeight: "bold",
                }}
              >
                "Please note that our company treats Return / Non-acceptance of
                orders by customers very strictly. In such events, COD facility
                shall be withdrawn and delivery charges might be applicable on
                subsequent orders of such customers.
                <br />
                In case of any disagreement with courier personnel or issue with
                the Order, please contact our support team at +91 9321927004"
              </p>
              <DialogContentText>
                {"Are you sure you want to checkout ?"}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleOnlineModalClose} color="secondary">
                Cancel
              </Button>
              <Button
                color="primary"
                disabled={isLoading}
                onClick={(e) => { claimForOpenCheckout(e); setOpenNewPopup(true); }}
              >
                Order
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={openNewPopup}
            onClose={handleOnlineModalClose}
            fullWidth={true}
            maxWidth={"sm"}
          >
            <DialogTitle className="pb-0 text-danger">
              MediWallet Notice:
            </DialogTitle>
            <DialogContent className="text-justify">
              <p style={{ marginBottom: "2px", fontWeight: "bold" }}>
                Any adjustment in prepaid or COD order value either directly, or
                indirectly through tickets would be credited to Mediwallet,
                which can be utilized for payments towards future prepaid
                orders. No encashment, bank/UPI transfers are allowed for
                Mediwallet credits except for the case where you choose to close
                MEDIMNY account.
              </p>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleOnlineModalClose} color="secondary">
                I decline & Cancel
              </Button>
              <Button
                color="primary"
                disabled={isLoading}
                onClick={() => {
                  if (mediTypeData) {
                    console.log("inside meditype");
                    handleMedicineOrder();
                  } else {
                    handleOnlineOrder();
                    console.log("inside onlineorder", individualSeller);
                  }
                }}
              >
                I understand and accept
              </Button>
            </DialogActions>
          </Dialog>
          {/* seller checkout dig */}
          <Dialog
            open={individualPop}
            onClose={handleOnlineModalClose}
            fullWidth={true}
            maxWidth={"sm"}
          >
            <DialogTitle style={{ paddingBottom: "0px" }}>
              Checkout: {individualSeller.name}
            </DialogTitle>
            <p
              style={{
                marginBottom: "2px",
                textAlign: "left",
                padding: "0px 25px",
                fontWeight: "bold",
              }}
            >
              "Please note that our company treats Return / Non-acceptance of
              orders by customers very strictly. In such events, COD facility
              shall be withdrawn and delivery charges might be applicable on
              subsequent orders of such customers.
              <br />
              In case of any disagreement with courier personnel or issue with
              the Order, please contact our support team at +91 9321927004"
            </p>
            <DialogContent className="pt-0">
              <DialogContentText style={{ marginBottom: "0px" }}>
                {"Are you sure you want to checkout ?"}
                <br />
                <div
                  className="col-xl-11 col-lg-11 col-md-11 col-sm-11 "
                  style={{ paddingLeft: "0px" }}
                >
                  <table style={{ width: "100%" }}>
                    {/* Price this seller's order with only ITS share of the claimed vouchers, mirroring
                        the main Order Summary: the product coupon comes off the GST-inclusive total at
                        face value, and no tier reduces the GST. */}
                    {(() => {
                      sellerVoucher = sellerSavings[
                        String(individualSeller && individualSeller.ID)
                      ] || {
                        coupons: 0,
                        cashback: 0,
                        platform: 0,
                      };
                      // Neither cashback is in `off` - both are post-delivery MediWallet credits, not
                      // payable reductions. Only the product coupon comes off what the buyer pays now.
                      const off = sellerVoucher.coupons;
                      const fullGst =
                        Number(individualSeller && individualSeller.gst) || 0;
                      const price =
                        Number(individualSeller && individualSeller.price) || 0;
                      // This seller's own claim state, not the cart-wide flag: claiming another
                      // seller must not price this seller's vouchers in behind the buyer's back.
                      sellerClaimed = isSellerClaimed(
                        individualSeller && individualSeller.ID,
                      );
                      sellerHasDiscount = Boolean(sellerClaimed && off > 0);
                      // This seller's liquid surcharge, added to the payable beside the delivery
                      // charge - see util/liquidSurcharge.
                      sellerLiquidSurcharge =
                        Number(individualSeller && individualSeller.liquidSurcharge) || 0;
                      sellerPayable = Math.max(
                        0,
                        price + fullGst + deliChrg + sellerLiquidSurcharge - off,
                      );
                      return null;
                    })()}
                    {users && (
                      <tr>
                        <td className="h4" style={{ justifyContent: "start" }}>
                          MediWallet:
                        </td>
                        <td
                          className="h3 mt-2"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          MNY{" "}
                          {users.wallet_balance.toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    )}
                    <tr height="25px">
                      <td className="h4" style={{ justifyContent: "start" }}>
                        Items Total:
                      </td>
                      <td
                        className="h4 mt-2"
                        style={{ justifyContent: "end", padding: 0 }}
                      >
                        ₹
                        {individualSeller &&
                          individualSeller.price.toLocaleString("en-IN", {
                            maximumFractionDigits: 2,
                          })}
                      </td>
                    </tr>
                    {/* Product Coupons sits BELOW Total GST and Delivery Charge - see the row further
                        down. It is a flat post-tax cut off the GST-inclusive total, so putting it above
                        GST would read as though it reduced the taxable value. */}
                    {/* No gift row - see the Order Summary. This table is what the buyer pays, and
                        the cart lines already say which items carry a gift. */}
                    {/* Both cashbacks moved BELOW the amount due at the foot of this table - neither
                        is taken off it, so neither belongs among the rows that build it up. */}
                    <tr height="25px">
                      <td
                        className="h4"
                        style={{ padding: 0, justifyContent: "start" }}
                      >
                        Total GST:
                      </td>
                      <td
                        className="h4 mt-2"
                        style={{ justifyContent: "end", padding: 0 }}
                      >
                        {/* Charged in full - no tier reduces the taxable value any more. */}
                        ₹
                        {(
                          Number(individualSeller && individualSeller.gst) || 0
                        ).toLocaleString("en-IN", { maximumFractionDigits: 2 })}
                      </td>
                    </tr>
                    {deliChrg > 0 ? (
                      <tr height="25px">
                        <td
                          className="h4"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          Delivery Charge:
                        </td>
                        <td
                          className="h4  mt-2"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          ₹
                          {deliChrg.toLocaleString("en-IN", {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    ) : (
                      ""
                    )}
                    {/* This seller's liquid surcharge - see the cart-wide row for what it is. Only
                        this seller's liquid lines, since only this seller is being checked out. */}
                    {sellerLiquidSurcharge > 0 ? (
                      <tr height="25px">
                        <td
                          className="h4"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          Liquid delivery charge:
                        </td>
                        <td
                          className="h4  mt-2"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          ₹
                          {sellerLiquidSurcharge.toLocaleString("en-IN", {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    ) : (
                      ""
                    )}
                    {/* The product coupon, taken off the GST-INCLUSIVE total above at face value. */}
                    {sellerHasDiscount && sellerVoucher.coupons > 0 && (
                      <tr height="25px">
                        <td
                          className="h4 text-success"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          Product Coupons:
                        </td>
                        <td
                          className="h4 mt-2 text-success"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          -₹
                          {sellerVoucher.coupons.toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    )}
                    {sellerHasDiscount ? (
                      <tr height="25px">
                        <td
                          className="h4 font-weight-bold"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          Payable:
                        </td>
                        <td
                          className="h4 mt-2 font-weight-bold"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          ₹
                          {sellerPayable.toLocaleString("en-IN", {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    ) : (
                      <tr height="25px">
                        <td
                          className="h4"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          Invoice Total:
                        </td>
                        <td
                          className="h4 mt-2"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          ₹
                          {sellerPayable.toLocaleString("en-IN", {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    )}
                    {isCodPrepayValid && selectedValue === "Partial" ? (
                      <tr height="25px">
                        <td className="h4">Prepay Amount:</td>
                        <td
                          className="h4 mt-2"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          {
                            <React.Fragment>
                              ₹{Number(PrpaymentCod).toFixed(2)}
                            </React.Fragment>
                          }
                        </td>
                      </tr>
                    ) : (
                      ""
                    )}
                    {users.wallet_balance > 0 && selectedValue === "Online" ? (
                      <tr height="25px">
                        <td
                          className="h4 text-success"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          MediWallet:
                        </td>
                        <td
                          className="h3  mt-2 text-success"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          {Number(sellerPayable) >
                          Number(users && users.wallet_balance) ? (
                            <React.Fragment>
                              -₹
                              {Number(users && users.wallet_balance).toFixed(2)}
                            </React.Fragment>
                          ) : Number(users && users.wallet_balance) === 0 ? (
                            <React.Fragment>₹{0}</React.Fragment>
                          ) : (
                            <React.Fragment>
                              -₹
                              {Number(sellerPayable).toLocaleString("en-IN", {
                                maximumFractionDigits: 2,
                              })}
                            </React.Fragment>
                          )}
                        </td>
                      </tr>
                    ) : users.wallet_balance < 0 &&
                      selectedValue === "Online" ? (
                      <tr height="25px">
                        <td
                          className="h4 text-success"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          MediWallet:
                        </td>
                        <td
                          className="h3  mt-2 text-success"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          <React.Fragment>
                            +₹
                            {Math.abs(users && users.wallet_balance).toFixed(2)}
                          </React.Fragment>
                        </td>
                      </tr>
                    ) : null}
                    {users.wallet_balance > 0 && selectedValue === "Partial" ? (
                      <tr height="25px">
                        <td
                          className="h4 text-success"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          MediWallet:
                        </td>
                        <td
                          className="h3  mt-2 text-success"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          {Number(PrpaymentCod) >
                          Number(users && users.wallet_balance) ? (
                            <React.Fragment>
                              -₹
                              {Number(users && users.wallet_balance).toFixed(2)}
                            </React.Fragment>
                          ) : Number(users && users.wallet_balance) === 0 ? (
                            <React.Fragment>₹{0}</React.Fragment>
                          ) : (
                            <React.Fragment>
                              -₹
                              {Number(PrpaymentCod).toLocaleString("en-IN", {
                                maximumFractionDigits: 2,
                              })}
                            </React.Fragment>
                          )}
                        </td>
                      </tr>
                    ) : users.wallet_balance < 0 &&
                      selectedValue === "Partial" ? (
                      <tr height="25px">
                        <td
                          className="h4 text-success"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          MediWallet:
                        </td>
                        <td
                          className="h3  mt-2 text-success"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          <React.Fragment>
                            +₹
                            {Math.abs(users && users.wallet_balance).toFixed(2)}
                          </React.Fragment>
                        </td>
                      </tr>
                    ) : null}
                    {isCodPrepayValid &&
                    selectedValue === "Partial" &&
                    individualSeller.coolChain === 0 &&
                    individualSeller.prepaid === 0 ? (
                      <tr>
                        <td
                          className="h4"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          Amount to be pay now:
                        </td>
                        <td
                          className="h3 "
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          {Number(
                            Number(PrpaymentCod) + individualDeliveryChrg,
                          ) < Number(users && users.wallet_balance) ? (
                            <React.Fragment>₹{0}</React.Fragment>
                          ) : (
                            <React.Fragment>
                              ₹
                              {Number(
                                Number(PrpaymentCod) +
                                  individualDeliveryChrg -
                                  Number(users && users.wallet_balance),
                              ).toFixed(2)}
                            </React.Fragment>
                          )}
                        </td>
                      </tr>
                    ) : null}
                    <tr height="25px">
                      <td className="font-weight-bold h4 text-maroon">
                        {selectedValue != "Online"
                          ? "Amount to be pay later "
                          : "Amount to be pay now"}
                        :
                      </td>
                      <td
                        className="font-weight-bold h4 text-red"
                        style={{ textAlign: "left", padding: 0 }}
                      >
                        {selectedValue === "Online" &&
                        Number(users && users.wallet_balance) >
                          Number(sellerPayable) ? (
                          <React.Fragment>₹{0}</React.Fragment>
                        ) : selectedValue === "Online" &&
                          Number(users && users.wallet_balance) <
                            Number(sellerPayable) ? (
                          <React.Fragment>
                            ₹
                            {(
                              Number(sellerPayable) -
                              Number(users && users.wallet_balance)
                            ).toLocaleString("en-IN", {
                              maximumFractionDigits: 2,
                            })}
                          </React.Fragment>
                        ) : selectedValue !== "Online" ? (
                          <React.Fragment>
                            ₹
                            {(
                              Number(sellerPayable) -
                              (selectedValue == "Partial"
                                ? Number(PrpaymentCod)
                                : 0)
                            ).toLocaleString("en-IN", {
                              maximumFractionDigits: 2,
                            })}
                          </React.Fragment>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                    {/* Under the amount due, not among the rows that make it up: both cashbacks are
                        MediWallet credits after delivery, which the card above the seller blocks in
                        the cart says once for the whole order. */}
                    {sellerClaimed && sellerVoucher.cashback > 0 && (
                      <tr height="25px">
                        <td
                          className="h4 text-success"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          Seller Cashback :
                        </td>
                        <td
                          className="h4 mt-2 text-success"
                          style={{ textAlign: "left", padding: 0 }}
                        >
                          ₹
                          {sellerVoucher.cashback.toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    )}
                    {sellerClaimed && sellerVoucher.platform > 0 && (
                      <tr height="25px">
                        <td
                          className="h4 text-success"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          Medimny Cashback :
                        </td>
                        <td
                          className="h4 mt-2 text-success"
                          style={{ textAlign: "left", padding: 0 }}
                        >
                          ₹
                          {sellerVoucher.platform.toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    )}
                  </table>
                </div>
                <hr />
                <h4 className="font-weight-bold mb-0 mt-3">Payment Type</h4>
                {deliChrg > 0 ? (
                  <Row>
                    <span className="text-sm text-gray-600 my-2">
                      <strong>Note:</strong> Order below ₹
                      {deliveryMaxRange?.value} will carry delivery charge
                      of&nbsp;
                      <strong className="text-danger">
                        ₹{newGlobalDeliveryCrg?.value.toLocaleString("en-IN")}
                      </strong>
                    </span>
                  </Row>
                ) : (
                  ""
                )}
                {showCodOption &&
                users &&
                users.cod &&
                users.cod === true &&
                users.codService &&
                users.codService === true &&
                globalCod &&
                globalCod.key === "globalCod" &&
                globalCod.value === "1" &&
                individualSeller.coolChain === 0 &&
                individualSeller.prepaid === 0 &&
                individualSeller.prepaidInven === 0 &&
                (totalDeliverd >= 10 ||
                  (totalOpenCOD < 5 &&
                    checkOutVal + codTotalAmount < 35000)) ? (
                  <Row style={{ marginBottom: "-6px" }}>
                    <Col md={5} xl={5} lg={5} sm={5} xs={5} className="mt-3">
                      <h4 className="mb-0">Cash on Delivery:</h4>
                    </Col>
                    <Col md={2} xl={2} lg={2} sm={2} xs={2} className="mt-1">
                      <Radio
                        color="primary"
                        checked={selectedValue === "COD"}
                        onChange={handleRadioChange}
                        value="COD"
                        name="radio button demo"
                        aria-label="A"
                      />
                    </Col>
                    <Col md={5} xl={5} lg={5} sm={5} xs={5}></Col>
                  </Row>
                ) : (
                  ""
                )}
                {isCodPrepayValid &&
                individualSeller.coolChain === 0 &&
                individualSeller.prepaid === 0 &&
                individualSeller.prepaidInven === 0 ? (
                  <Row>
                    {selectedValue === "Partial" && isCodPrepayValid ? (
                      <span className="text-sm text-gray-600 my-2">
                        <strong>Note:</strong> Since you have opted for a
                        partial payment order, you will need to pay&nbsp;
                        <strong className="text-danger">
                          ₹{PrpaymentCod.toLocaleString("en-IN")}
                        </strong>{" "}
                        to proceed.
                      </span>
                    ) : null}
                    <Col md={5} xl={5} lg={5} sm={5} xs={5} className="mt-3">
                      <h4 className="mb-0">Partial Payment:</h4>
                    </Col>
                    <Col md={2} xl={2} lg={2} sm={2} xs={2} className="mt-2">
                      <Radio
                        color="primary"
                        checked={selectedValue === "Partial"}
                        onChange={handleRadioChange}
                        value="Partial"
                        name="radio button demo"
                        aria-label="A"
                      />
                    </Col>
                    <Col md={5} xl={5} lg={5} sm={5} xs={5}></Col>
                  </Row>
                ) : (
                  ""
                )}
                {!asAdmin ? (
                  <Row>
                    <Col md={5} xl={5} lg={5} sm={5} xs={5} className="mt-2">
                      <h4>Pay Now:</h4>
                    </Col>
                    <Col md={2} xl={2} lg={2} sm={2} xs={2}>
                      <Radio
                        color="primary"
                        checked={selectedValue === "Online"}
                        onChange={handleRadioChange}
                        value="Online"
                        name="radio button demo"
                        aria-label="B"
                      />
                    </Col>
                    <Col md={5} xl={5} lg={5} sm={5} xs={5}></Col>
                  </Row>
                ) : (
                  ""
                )}

                {showUpiToggle &&
                (selectedValue === "Online"
                  ? Number(
                      individualSeller.gst + individualSeller.price + deliChrg,
                    ) > Number(users && users.wallet_balance)
                  : Number(Number(PrpaymentCod) + individualDeliveryChrg) >
                    Number(users && users.wallet_balance)) ? (
                  //last change
                  <>
                    <hr />
                    <h3 className="font-weight-bold ">Payment Method</h3>
                    <Row>
                      <Col md={5} xl={5} lg={5} sm={5} xs={5} className="mt-2">
                        <h4>Pay with UPI:</h4>
                      </Col>
                      <Col md={2} xl={2} lg={2} sm={2} xs={2}>
                        <Radio
                          color="primary"
                          checked={upiType === "upi"}
                          onChange={upiRadioChange}
                          value="upi"
                          name="radio button demo"
                          aria-label="A"
                        />
                      </Col>
                      <Col md={5} xl={5} lg={5} sm={5} xs={5}></Col>
                    </Row>
                    <Row>
                      <Col md={5} xl={5} lg={5} sm={5} xs={5} className="mt-2">
                        <h4>Credit/Debit/Other:</h4>
                      </Col>
                      <Col md={2} xl={2} lg={2} sm={2} xs={2}>
                        <Radio
                          color="primary"
                          checked={upiType === "credit"}
                          onChange={upiRadioChange}
                          value="credit"
                          name="radio button demo"
                          aria-label="A"
                        />
                      </Col>
                      <Col md={5} xl={5} lg={5} sm={5} xs={5}></Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}
                {Number(individualSeller.price) > 5000 &&
                individualSeller.bnplOption === true &&
                users.isBnpl === true &&
                globalBnpl &&
                globalBnpl.value === "1" &&
                bnplBal > Number(individualSeller.price) ? (
                  <Row>
                    <Col md={5} xl={5} lg={5} sm={5} xs={5} className="mt-2">
                      <h4 className="mb-0">BNPL :</h4>
                      <span style={{ fontSize: "14px", color: "black" }}>
                        {" "}
                        Available limit:{" "}
                      </span>{" "}
                      <span style={{ color: "green", fontSize: "14px" }}>
                        ₹
                        {bnplBal.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </Col>
                    <Col md={2} xl={2} lg={2} sm={2} xs={2}>
                      <Radio
                        color="primary"
                        checked={selectedValue === "BNPL"}
                        onChange={handleRadioChange}
                        value="BNPL"
                        name="radio button demo"
                        aria-label="C"
                      />
                    </Col>
                    <Col md={5} xl={5} lg={5} sm={5} xs={5}></Col>
                  </Row>
                ) : Number(individualSeller.price) > 5000 &&
                  individualSeller.bnplOption === true &&
                  users.isBnpl === true &&
                  globalBnpl &&
                  globalBnpl.value === "1" &&
                  bnplBal < Number(individualSeller.price) ? (
                  <Row>
                    <Col md={5} xl={5} lg={5} sm={5} xs={5} className="mt-2">
                      <h4 className="mb-0">BNPL :</h4>
                      <span style={{ fontSize: "14px", color: "black" }}>
                        {" "}
                        Available limit:{" "}
                      </span>{" "}
                      <span style={{ color: "green", fontSize: "14px" }}>
                        ₹
                        {bnplBal.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </Col>
                    <Col md={2} xl={2} lg={2} sm={2} xs={2}>
                      <Radio
                        color="primary"
                        checked={selectedValue === "BNPL"}
                        disabled={true}
                        value="BNPL"
                        name="radio button demo"
                        aria-label="C"
                      />
                    </Col>
                    <Col md={5} xl={5} lg={5} sm={5} xs={5}></Col>
                  </Row>
                ) : (
                  ""
                )}
              </DialogContentText>
              <DialogActions style={{ paddingRight: "0px" }}>
                <Button
                  onClick={handleOnlineModalClose}
                  style={{ paddingRight: "0px" }}
                  color="secondary"
                >
                  Cancel
                </Button>
                {selectedValue === "BNPL" ? (
                  <Button
                    color="primary"
                    disabled={
                      isLoading ||
                      (showUpiToggle &&
                        Number(Number(PrpaymentCod) + individualDeliveryChrg) >
                          Number(users && users.wallet_balance) &&
                        upiType === "")
                    }
                    onClick={(e) => { claimForOpenCheckout(e); setOtpModel(true); }}
                  >
                    Order
                  </Button>
                ) : selectedValue === "COD" ? (
                  <Button
                    color="primary"
                    disabled={isLoading}
                    onClick={handleOnlineModal}
                  >
                    Order
                  </Button>
                ) : selectedValue === "Online" ? (
                  <Button
                    color="primary"
                    disabled={
                      isLoading ||
                      (showUpiToggle &&
                        Number(
                          individualSeller.gst +
                            individualSeller.price +
                            deliChrg,
                        ) > Number(users && users.wallet_balance) &&
                        upiType === "")
                    }
                    onClick={(e) => { claimForOpenCheckout(e); setOpenNewPopup(true); }}
                  >
                    Order
                  </Button>
                ) : selectedValue !== "" ? (
                  <Button
                    color="primary"
                    disabled={
                      isLoading ||
                      (showUpiToggle &&
                        Number(Number(PrpaymentCod) + individualDeliveryChrg) >
                          Number(users && users.wallet_balance) &&
                        upiType === "")
                    }
                    onClick={handleOnlineOrder}
                  >
                    Order
                  </Button>
                ) : (
                  <Button
                    color="primary"
                    style={{ cursor: "pointer", paddingRight: "0px" }}
                  >
                    Select Payment Method
                  </Button>
                )}
              </DialogActions>
            </DialogContent>
            {/* medicine checkout dig */}
          </Dialog>
          {/* medicine checkout dig */}
          <Dialog
            open={medicinePop}
            onClose={handleOnlineModalClose}
            fullWidth={true}
            maxWidth={"sm"}
          >
            <DialogTitle style={{ paddingBottom: "0px" }}>
              Checkout: {`${mediTypeData.name} (${mediTypeData.key})`}
            </DialogTitle>
            <p
              style={{
                marginBottom: "2px",
                textAlign: "left",
                padding: "0px 25px",
                fontWeight: "bold",
              }}
            >
              "Please note that our company treats Return / Non-acceptance of
              orders by customers very strictly. In such events, COD facility
              shall be withdrawn and delivery charges might be applicable on
              subsequent orders of such customers.
              <br />
              In case of any disagreement with courier personnel or issue with
              the Order, please contact our support team at +91 9321927004"
            </p>
            <DialogContent className="pt-0">
              <DialogContentText style={{ marginBottom: "0px" }}>
                {"Are you sure you want to checkout ?"}
                <br />
                <div
                  className="col-xl-11 col-lg-11 col-md-11 col-sm-11 "
                  style={{ paddingLeft: "0px" }}
                >
                  <table style={{ width: "100%" }}>
                    {/* Price this seller's ONE block with only its share of the claimed vouchers,
                        mirroring the main Order Summary: the product coupon comes off the GST-inclusive
                        total at face value, and no tier reduces the GST. */}
                    {(() => {
                      const block =
                        mediTypeData.key === "Cool chain" ? "cool" : "other";
                      mediVoucher = blockSavings[
                        `${mediTypeData && mediTypeData.ID}|${block}`
                      ] || {
                        coupons: 0,
                        cashback: 0,
                        platform: 0,
                      };
                      // Neither cashback is in `off` - both are post-delivery MediWallet credits, not
                      // payable reductions. Only the product coupon comes off what the buyer pays now.
                      const off = mediVoucher.coupons;
                      const price =
                        Number(
                          mediTypeData.key === "Cool chain"
                            ? mediTypeData.coolChain
                            : mediTypeData.key === "Ethical branded"
                              ? mediTypeData.ethical
                              : mediTypeData.key === "Generic"
                                ? mediTypeData.generic
                                : 0,
                        ) || 0;
                      const fullGst =
                        Number(
                          mediTypeData.key === "Cool chain"
                            ? mediTypeData.coolChainGst
                            : mediTypeData.key === "Ethical branded"
                              ? mediTypeData.ethicalGst
                              : mediTypeData.key === "Generic"
                                ? mediTypeData.genericGst
                                : 0,
                        ) || 0;
                      // THIS block only, not the whole seller: `block` above is already the
                      // cool-chain / everything-else split, and claiming the seller's other order
                      // type must not make this one read as claimed.
                      mediClaimed = isBlockClaimed(
                        mediTypeData && mediTypeData.ID,
                        block,
                      );
                      mediHasDiscount = Boolean(mediClaimed && off > 0);
                      // Split the same way `price` and `fullGst` are: this block's liquid lines
                      // only. The Generic branch has no aggregate of its own (neither does its GST
                      // above - see genericGst, commented out at the source), so it reads 0.
                      mediLiquidSurcharge =
                        Number(
                          mediTypeData.key === "Cool chain"
                            ? mediTypeData.coolChainLiquidSurcharge
                            : mediTypeData.key === "Ethical branded"
                              ? mediTypeData.ethicalLiquidSurcharge
                              : 0,
                        ) || 0;
                      mediPayable = Math.max(
                        0,
                        price +
                          fullGst +
                          Number(individualCharges || 0) +
                          mediLiquidSurcharge -
                          off,
                      );
                      return null;
                    })()}
                    {users && (
                      <tr>
                        <td className="h4" style={{ justifyContent: "start" }}>
                          MediWallet:
                        </td>
                        <td
                          className="h3 mt-2"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          MNY{" "}
                          {users.wallet_balance.toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    )}
                    <tr height="25px">
                      <td className="h4" style={{ justifyContent: "start" }}>
                        Items Total:
                      </td>
                      <td
                        className="h4 mt-2"
                        style={{ justifyContent: "end", padding: 0 }}
                      >
                        ₹
                        {(mediTypeData.key === "Cool chain"
                          ? mediTypeData.coolChain
                          : mediTypeData.key === "Ethical branded"
                            ? mediTypeData.ethical
                            : mediTypeData.key === "Generic"
                              ? mediTypeData.generic
                              : 0
                        ).toLocaleString("en-IN", { maximumFractionDigits: 2 })}
                      </td>
                    </tr>
                    {/* Product Coupons sits BELOW Total GST and Delivery Charge - see the row further
                        down. It is a flat post-tax cut off the GST-inclusive total, so putting it above
                        GST would read as though it reduced the taxable value. */}
                    {/* No gift row - see the Order Summary. */}
                    {/* Both cashbacks moved BELOW the amount due at the foot of this table - neither
                        is taken off it, so neither belongs among the rows that build it up. */}
                    <tr height="25px">
                      <td
                        className="h4"
                        style={{ padding: 0, justifyContent: "start" }}
                      >
                        Total GST:
                      </td>
                      <td
                        className="h4 mt-2"
                        style={{ justifyContent: "end", padding: 0 }}
                      >
                        {/* Charged in full - no tier reduces the taxable value any more. */}
                        ₹
                        {(Number(
                          mediTypeData.key === "Cool chain"
                            ? mediTypeData.coolChainGst
                            : mediTypeData.key === "Ethical branded"
                              ? mediTypeData.ethicalGst
                              : mediTypeData.key === "Generic"
                                ? mediTypeData.genericGst
                                : 0,
                        ) || 0).toLocaleString("en-IN", {
                          maximumFractionDigits: 2,
                        })}
                      </td>
                    </tr>
                    {individualCharges > 0 ? (
                      <tr height="25px">
                        <td
                          className="h4"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          Delivery Charge:
                        </td>
                        <td
                          className="h4  mt-2"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          ₹
                          {Number(individualCharges).toLocaleString("en-IN", {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    ) : (
                      ""
                    )}
                    {/* This block's liquid surcharge - see the cart-wide row for what it is. Split
                        by medicine type the same way the Items Total and GST above are. */}
                    {mediLiquidSurcharge > 0 ? (
                      <tr height="25px">
                        <td
                          className="h4"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          Liquid delivery charge:
                        </td>
                        <td
                          className="h4  mt-2"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          ₹
                          {mediLiquidSurcharge.toLocaleString("en-IN", {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    ) : (
                      ""
                    )}
                    {/* The product coupon, taken off the GST-INCLUSIVE total above at face value. */}
                    {mediHasDiscount && mediVoucher.coupons > 0 && (
                      <tr height="25px">
                        <td
                          className="h4 text-success"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          Product Coupons:
                        </td>
                        <td
                          className="h4 mt-2 text-success"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          -₹
                          {mediVoucher.coupons.toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    )}
                    {mediHasDiscount ? (
                      <tr height="25px">
                        <td
                          className="h4 font-weight-bold"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          Payable:
                        </td>
                        <td
                          className="h4 mt-2 font-weight-bold"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          ₹
                          {mediPayable.toLocaleString("en-IN", {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    ) : (
                      <tr height="25px">
                        <td
                          className="h4"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          Invoice Total:
                        </td>
                        <td
                          className="h4 mt-2"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          ₹
                          {mediPayable.toLocaleString("en-IN", {
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    )}
                    {users.wallet_balance > 0 && selectedValue === "Online" ? (
                      <tr height="25px">
                        <td
                          className="h4 text-success"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          MediWallet:
                        </td>
                        <td
                          className="h3  mt-2 text-success"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          {Number(mediPayable) >
                          Number(users && users.wallet_balance) ? (
                            <React.Fragment>
                              -₹
                              {Number(users && users.wallet_balance).toFixed(2)}
                            </React.Fragment>
                          ) : Number(users && users.wallet_balance) === 0 ? (
                            <React.Fragment>₹{0}</React.Fragment>
                          ) : (
                            <React.Fragment>
                              -₹
                              {Number(mediPayable).toLocaleString("en-IN", {
                                maximumFractionDigits: 2,
                              })}
                            </React.Fragment>
                          )}
                        </td>
                      </tr>
                    ) : users.wallet_balance < 0 &&
                      selectedValue === "Online" ? (
                      <tr height="25px">
                        <td
                          className="h4 text-success"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          MediWallet:
                        </td>
                        <td
                          className="h3  mt-2 text-success"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          <React.Fragment>
                            +₹
                            {Math.abs(users && users.wallet_balance).toFixed(2)}
                          </React.Fragment>
                        </td>
                      </tr>
                    ) : null}
                    {isCodPrepayValid &&
                    selectedValue === "Partial" &&
                    !mediTypeData.showCodForProd &&
                    !mediTypeData.showCodForInven &&
                    mediTypeData.key === "Ethical branded" ? (
                      <tr height="25px">
                        <td
                          className="h4"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          Prepay Amount:
                        </td>
                        <td
                          className="h4 mt-2"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          {
                            <React.Fragment>
                              ₹{Number(mediprepayment).toFixed(2)}
                            </React.Fragment>
                          }
                        </td>
                      </tr>
                    ) : (
                      ""
                    )}
                    {users.wallet_balance > 0 &&
                    selectedValue === "Partial" &&
                    !mediTypeData.showCodForProd &&
                    !mediTypeData.showCodForInven &&
                    mediTypeData.key === "Ethical branded" ? (
                      <tr height="25px">
                        <td
                          className="h4 text-success"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          MediWallet:
                        </td>
                        <td
                          className="h3  mt-2 text-success"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          {Number(Number(mediprepayment)) >
                          Number(users && users.wallet_balance) ? (
                            <React.Fragment>
                              -₹
                              {Number(users && users.wallet_balance).toFixed(2)}
                            </React.Fragment>
                          ) : Number(users && users.wallet_balance) === 0 ? (
                            <React.Fragment>₹{0}</React.Fragment>
                          ) : (
                            <React.Fragment>
                              -₹
                              {Number(mediprepayment).toLocaleString("en-IN", {
                                maximumFractionDigits: 2,
                              })}
                            </React.Fragment>
                          )}
                        </td>
                      </tr>
                    ) : users.wallet_balance < 0 &&
                      selectedValue === "Partial" &&
                      mediTypeData.key === "Ethical branded" ? (
                      <tr height="25px">
                        <td
                          className="h4 text-success"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          MediWallet:
                        </td>
                        <td
                          className="h3  mt-2 text-success"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          <React.Fragment>
                            +₹
                            {Math.abs(users && users.wallet_balance).toFixed(2)}
                          </React.Fragment>
                        </td>
                      </tr>
                    ) : null}
                    {isCodPrepayValid &&
                    selectedValue === "Partial" &&
                    !mediTypeData.showCodForProd &&
                    !mediTypeData.showCodForInven &&
                    mediTypeData.key === "Ethical branded" ? (
                      <tr height="25px">
                        <td
                          className="h4"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          Amount to be pay now:
                        </td>
                        <td
                          className="h3 mt-2"
                          style={{ justifyContent: "end", padding: 0 }}
                        >
                          {Number(mediprepayment) <
                          Number(users?.wallet_balance) ? (
                            <>₹0</>
                          ) : Number(users?.wallet_balance) === 0 ? (
                            <>-₹{Number(mediprepayment).toFixed(2)}</>
                          ) : (
                            <>
                              -₹
                              {(
                                Number(mediprepayment) -
                                Number(users?.wallet_balance)
                              ).toFixed(2)}
                            </>
                          )}
                        </td>
                      </tr>
                    ) : null}
                    <tr height="25px">
                      <td className="font-weight-bold h4 text-maroon">
                        {selectedValue != "Online"
                          ? "Amount to be pay later "
                          : "Amount to be pay now"}
                        :
                      </td>
                      <td
                        className="font-weight-bold h4 text-red"
                        style={{ textAlign: "left", padding: 0 }}
                      >
                        {selectedValue === "Online" &&
                        Number(users && users.wallet_balance) >
                          Number(mediPayable) ? (
                          <React.Fragment>₹{0}</React.Fragment>
                        ) : selectedValue === "Online" &&
                          Number(users && users.wallet_balance) <
                            Number(mediPayable) ? (
                          <React.Fragment>
                            ₹
                            {(
                              Number(mediPayable) -
                              Number(users && users.wallet_balance)
                            ).toLocaleString("en-IN", {
                              maximumFractionDigits: 2,
                            })}
                          </React.Fragment>
                        ) : selectedValue !== "Online" ? (
                          <React.Fragment>
                            ₹
                            {Number(
                              Number(mediPayable) -
                                (selectedValue == "Partial"
                                  ? Number(mediprepayment)
                                  : 0),
                            ).toLocaleString("en-IN", {
                              maximumFractionDigits: 2,
                            })}
                          </React.Fragment>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                    {/* Under the amount due, not among the rows that make it up: both cashbacks are
                        MediWallet credits after delivery, which the card above the seller blocks in
                        the cart says once for the whole order. */}
                    {mediClaimed && mediVoucher.cashback > 0 && (
                      <tr height="25px">
                        <td
                          className="h4 text-success"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          Seller Cashback :
                        </td>
                        <td
                          className="h4 mt-2 text-success"
                          style={{ textAlign: "left", padding: 0 }}
                        >
                          ₹
                          {mediVoucher.cashback.toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    )}
                    {mediClaimed && mediVoucher.platform > 0 && (
                      <tr height="25px">
                        <td
                          className="h4 text-success"
                          style={{ padding: 0, justifyContent: "start" }}
                        >
                          Medimny Cashback :
                        </td>
                        <td
                          className="h4 mt-2 text-success"
                          style={{ textAlign: "left", padding: 0 }}
                        >
                          ₹
                          {mediVoucher.platform.toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    )}
                  </table>
                </div>
                <hr />
                <h4 className="font-weight-bold mb-0 mt-3">Payment Type</h4>
                {individualCharges > 0 ? (
                  <Row>
                    <span className="text-sm text-gray-600 my-2">
                      <strong>Note:</strong> Order below ₹
                      {deliveryMaxRange?.value} will carry delivery charge
                      of&nbsp;
                      <strong className="text-danger">
                        ₹{newGlobalDeliveryCrg?.value.toLocaleString("en-IN")}
                      </strong>
                    </span>
                  </Row>
                ) : (
                  ""
                )}
                {showCodOption &&
                users &&
                users.cod &&
                users.cod === true &&
                users.codService &&
                users.codService === true &&
                globalCod &&
                globalCod.key === "globalCod" &&
                globalCod.value === "1" &&
                !mediTypeData.showCod &&
                !mediTypeData.showCodForProd &&
                !mediTypeData.showCodForInven &&
                (totalDeliverd >= 10 ||
                  (totalOpenCOD < 5 &&
                    prodcheckOutVal + codTotalAmount < 35000)) ? (
                  <Row style={{ marginBottom: "-6px" }}>
                    <Col md={5} xl={5} lg={5} sm={5} xs={5} className="mt-3">
                      <h4 className="mb-0">Cash on Delivery:</h4>
                    </Col>
                    <Col md={2} xl={2} lg={2} sm={2} xs={2} className="mt-1">
                      <Radio
                        color="primary"
                        checked={selectedValue === "COD"}
                        onChange={handleRadioChange}
                        value="COD"
                        name="radio button demo"
                        aria-label="A"
                      />
                    </Col>
                    <Col md={5} xl={5} lg={5} sm={5} xs={5}></Col>
                  </Row>
                ) : (
                  ""
                )}
                {users &&
                isCodPrepayValid &&
                !mediTypeData.showCodForProd &&
                !mediTypeData.showCodForInven &&
                mediTypeData.key === "Ethical branded" ? (
                  <Row>
                    {selectedValue === "Partial" && isCodPrepayValid ? (
                      <span className="text-sm text-gray-600 my-2">
                        <strong>Note:</strong> Since you have opted for a
                        partial payment order, you will need to pay&nbsp;
                        <strong className="text-danger">
                          {/* ₹{(
                            Math.ceil(
                              (
                                (
                                  mediTypeData.key === 'Cool chain'
                                    ? mediTypeData.coolChain + mediTypeData.coolChainGst
                                    : mediTypeData.key === 'Ethical branded'
                                      ? mediTypeData.ethical + mediTypeData.ethicalGst

                                      : 0
                                ) +
                                individualDeliveryChrg
                              ) * (users.codPrepayPer / 100) / 100
                            ) * 100
                          ).toLocaleString('en-IN')} */}
                          ₹{mediprepayment.toLocaleString("en-IN")}
                        </strong>{" "}
                        to proceed.
                      </span>
                    ) : null}
                    <Col md={5} xl={5} lg={5} sm={5} xs={5} className="mt-3">
                      <h4 className="mb-0">Partial Payment:</h4>
                    </Col>
                    <Col md={2} xl={2} lg={2} sm={2} xs={2} className="mt-2">
                      <Radio
                        color="primary"
                        checked={selectedValue === "Partial"}
                        onChange={handleRadioChange}
                        value="Partial"
                        name="radio button demo"
                        aria-label="A"
                      />
                    </Col>
                  </Row>
                ) : (
                  ""
                )}
                {!asAdmin ? (
                  <Row>
                    <Col md={5} xl={5} lg={5} sm={5} xs={5} className="mt-2">
                      <h4>Pay Now:</h4>
                    </Col>
                    <Col md={2} xl={2} lg={2} sm={2} xs={2}>
                      <Radio
                        color="primary"
                        checked={selectedValue === "Online"}
                        onChange={handleRadioChange}
                        value="Online"
                        name="radio button demo"
                        aria-label="B"
                      />
                    </Col>
                    <Col md={5} xl={5} lg={5} sm={5} xs={5}></Col>
                  </Row>
                ) : (
                  ""
                )}
                {showUpiToggle &&
                (selectedValue === "Online"
                  ? Number(getMediTypeAmount(mediTypeData)) >
                    Number(users && users.wallet_balance)
                  : Number(mediprepayment) > Number(users?.wallet_balance)) ? (
                  <>
                    <hr />
                    <h3 className="font-weight-bold ">Payment Method</h3>
                    <Row>
                      <Col md={5} xl={5} lg={5} sm={5} xs={5} className="mt-2">
                        <h4>Pay with UPI:</h4>
                      </Col>
                      <Col md={2} xl={2} lg={2} sm={2} xs={2}>
                        <Radio
                          color="primary"
                          checked={upiType === "upi"}
                          onChange={upiRadioChange}
                          value="upi"
                          name="radio button demo"
                          aria-label="A"
                        />
                      </Col>
                      <Col md={5} xl={5} lg={5} sm={5} xs={5}></Col>
                    </Row>
                    <Row>
                      <Col md={5} xl={5} lg={5} sm={5} xs={5} className="mt-2">
                        <h4>Credit/Debit/Other:</h4>
                      </Col>
                      <Col md={2} xl={2} lg={2} sm={2} xs={2}>
                        <Radio
                          color="primary"
                          checked={upiType === "credit"}
                          onChange={upiRadioChange}
                          value="credit"
                          name="radio button demo"
                          aria-label="A"
                        />
                      </Col>
                      <Col md={5} xl={5} lg={5} sm={5} xs={5}></Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}
                {Number(mediTypeData.price) > 5000 &&
                users.isBnpl === true &&
                globalBnpl &&
                globalBnpl.value === "1" &&
                bnplBal > Number(mediTypeData.price) ? (
                  <Row>
                    <Col md={5} xl={5} lg={5} sm={5} xs={5} className="mt-2">
                      <h4 className="mb-0">BNPL :</h4>
                      <span style={{ fontSize: "14px", color: "black" }}>
                        {" "}
                        Available limit:{" "}
                      </span>{" "}
                      <span style={{ color: "green", fontSize: "14px" }}>
                        ₹
                        {bnplBal.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </Col>
                    <Col md={2} xl={2} lg={2} sm={2} xs={2}>
                      <Radio
                        color="primary"
                        checked={selectedValue === "BNPL"}
                        onChange={handleRadioChange}
                        value="BNPL"
                        name="radio button demo"
                        aria-label="C"
                      />
                    </Col>
                    <Col md={5} xl={5} lg={5} sm={5} xs={5}></Col>
                  </Row>
                ) : Number(mediTypeData.price) > 5000 &&
                  users.isBnpl === true &&
                  globalBnpl &&
                  globalBnpl.value === "1" &&
                  bnplBal < Number(mediTypeData.price) ? (
                  <Row>
                    <Col md={5} xl={5} lg={5} sm={5} xs={5} className="mt-2">
                      <h4 className="mb-0">BNPL :</h4>
                      <span style={{ fontSize: "14px", color: "black" }}>
                        {" "}
                        Available limit:{" "}
                      </span>{" "}
                      <span style={{ color: "green", fontSize: "14px" }}>
                        ₹
                        {bnplBal.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </Col>
                    <Col md={2} xl={2} lg={2} sm={2} xs={2}>
                      <Radio
                        color="primary"
                        checked={selectedValue === "BNPL"}
                        disabled={true}
                        value="BNPL"
                        name="radio button demo"
                        aria-label="C"
                      />
                    </Col>
                    <Col md={5} xl={5} lg={5} sm={5} xs={5}></Col>
                  </Row>
                ) : (
                  ""
                )}
              </DialogContentText>
              <DialogActions style={{ paddingRight: "0px" }}>
                <Button
                  onClick={handleOnlineModalClose}
                  style={{ paddingRight: "0px" }}
                  color="secondary"
                >
                  Cancel
                </Button>
                {selectedValue === "BNPL" ? (
                  <Button
                    color="primary"
                    disabled={isLoading || (showUpiToggle && upiType === "")}
                    onClick={(e) => { claimForOpenCheckout(e); setOtpModel(true); }}
                  >
                    Order
                  </Button>
                ) : selectedValue === "COD" ? (
                  <Button
                    color="primary"
                    disabled={isLoading}
                    onClick={handleOnlineModal}
                  >
                    Order
                  </Button>
                ) : selectedValue === "Online" ? (
                  <Button
                    color="primary"
                    disabled={
                      isLoading ||
                      (showUpiToggle &&
                        Number(getMediTypeAmount(mediTypeData)) >
                          Number(users?.wallet_balance) &&
                        upiType === "")
                    }
                    onClick={(e) => { claimForOpenCheckout(e); setOpenNewPopup(true); }}
                  >
                    Order
                  </Button>
                ) : selectedValue !== "" ? (
                  <Button
                    color="primary"
                    disabled={
                      isLoading ||
                      (showUpiToggle &&
                        Number(mediprepayment) >
                          Number(users?.wallet_balance) &&
                        upiType === "")
                    }
                    onClick={handleMedicineOrder}
                  >
                    Order
                  </Button>
                ) : (
                  <Button
                    color="primary"
                    style={{ cursor: "pointer", paddingRight: "0px" }}
                  >
                    Select Payment Method
                  </Button>
                )}
              </DialogActions>
            </DialogContent>
          </Dialog>

          <Dialog
            open={acceptModal}
            onClose={handleAcceptClose}
            fullWidth={true}
          >
            <DialogContent style={{ overflow: "hidden" }}>
              <DialogTitle
                className=""
                id="alert-dialog-title"
                style={{ textAlign: "center" }}
              >
                <span className="text-success mb-3">
                  <i class="zmdi zmdi-check-circle animated fadeInUp zmdi-hc-5x"></i>
                </span>
                <h1 className="mt-4 font-weight-bold">
                  Order Placed Successfully
                </h1>
              </DialogTitle>
              <h3 style={{ textAlign: "center" }}>
                <p>
                  Your order {`${successData.length > 12 ? `id's:` : "id:"}`}
                </p>
                {successData && successData}
              </h3>
              {/* What the vouchers took off this order, tier by tier. Snapshotted at placement:
                  the cart is emptied by then, so there is nothing left here to recompute from. */}
              {orderSavings &&
                (orderSavings.total > 0 || orderSavings.platform > 0) && (
                  <div className="mt-3">
                    {orderSavings.total > 0 && (
                      <h3
                        className="text-success font-weight-bold"
                        style={{ textAlign: "center" }}
                      >
                        You saved ₹{orderSavings.total.toFixed(2)}
                      </h3>
                    )}
                    <table style={{ width: "100%" }}>
                      {orderSavings.coupons > 0 && (
                        <tr>
                          <td className="h4" style={{ padding: 0 }}>
                            Product coupons
                          </td>
                          <td
                            className="h4 text-success"
                            style={{ textAlign: "right", padding: 0 }}
                          >
                            ₹{orderSavings.coupons.toFixed(2)}
                          </td>
                        </tr>
                      )}
                      {/* The gift is packed with the order rather than paid out, so it has no rupee
                        figure here - but it is the whole reward on a gift-only order, and without
                        this row that order's success modal confirmed nothing at all. */}
                      {orderSavings.gifts > 0 && (
                        <tr>
                          <td className="h4" style={{ padding: 0 }}>
                            Free gift{orderSavings.gifts > 1 ? "s" : ""}{" "}
                          </td>
                          <td
                            className="h4 text-success"
                            style={{ textAlign: "right", padding: 0 }}
                          >
                            {orderSavings.gifts} on the way
                          </td>
                        </tr>
                      )}
                      {/* Both cashbacks are credited to the buyer's MediWallet once the order is
                        delivered - not part of the immediate "You saved" above. */}
                      {orderSavings.cashback > 0 && (
                        <tr>
                          <td className="h4" style={{ padding: 0 }}>
                            Seller cashback{" "}
                          </td>
                          <td
                            className="h4 text-success"
                            style={{ textAlign: "right", padding: 0 }}
                          >
                            ₹{orderSavings.cashback.toFixed(2)}
                          </td>
                        </tr>
                      )}
                      {orderSavings.platform > 0 && (
                        <tr>
                          <td className="h4" style={{ padding: 0 }}>
                            Medimny cashback{" "}
                          </td>
                          <td
                            className="h4 text-success"
                            style={{ textAlign: "right", padding: 0 }}
                          >
                            ₹{orderSavings.platform.toFixed(2)}
                          </td>
                        </tr>
                      )}
                    </table>
                  </div>
                )}
            </DialogContent>
            <DialogActions className="pr-4">
              <Button onClick={handleAcceptClose} color="secondary">
                Shop More
              </Button>
            </DialogActions>
          </Dialog>

          <ClaimVouchersModal
            open={voucherModalKey != null}
            group={
              voucherModalKey
                ? voucherBlockGroups.find(
                    (g) => blockKey(g.sellerId, g.block) === voucherModalKey,
                  ) || null
                : null
            }
            claimedKeys={claimedVoucherKeys}
            blockClaimed={
              voucherModalKey
                ? claimedBlocks.indexOf(voucherModalKey) > -1
                : false
            }
            onClaimAll={claimAllVouchers}
            onClose={() => setVoucherModalKey(null)}
          />

          {/* The picture of whichever gift banner was clicked, over the cart. One dialog for all of
              them - the seller's, Medimny's and the card at the top - since only one can be open at
              a time. Laid out like the gift popup on the product detail page. */}
          <Dialog
            open={!!giftView}
            onClose={() => setGiftView(null)}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle className="pb-1">
              {(giftView && giftView.description) || "Free gift"}
              {giftView && giftView.brand ? (
                <span
                  className="text-muted"
                  style={{ fontSize: 13, marginLeft: 8 }}
                >
                  by {giftView.brand}
                </span>
              ) : null}
            </DialogTitle>
            <DialogContent>
              <img
                src={(giftView && giftView.image) || ""}
                alt={(giftView && giftView.description) || "Free gift"}
                style={{
                  display: "block",
                  margin: "0 auto",
                  maxWidth: "100%",
                  maxHeight: "70vh",
                  objectFit: "contain",
                  borderRadius: 4,
                }}
              />
              {giftView && Number(giftView.price) > 0 ? (
                <p
                  className="text-center mb-0 mt-3"
                  style={{ fontWeight: 600 }}
                >
                  Worth ₹{inr(giftView.price)}, free with this order.
                </p>
              ) : null}
            </DialogContent>
            <DialogActions className="pr-4">
              <Button onClick={() => setGiftView(null)} color="secondary">
                Close
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={otpModel}
            onClose={handleCloseOtpModel}
            fullWidth={true}
            maxWidth={"sm"}
          >
            <DialogTitle>
              BNPL Order
              <DialogContentText className="mt-0 mb-0">
                Order will be paid through BNPL, please enter OTP.
              </DialogContentText>
            </DialogTitle>
            <DialogContent>
              <Row>
                <Col
                  xs={4}
                  sm={4}
                  md={4}
                  lg={4}
                  xl={4}
                  style={{ paddingTop: "19px" }}
                >
                  <Button
                    onClick={getOtp}
                    color="primary"
                    variant="outlined"
                    fullWidth={true}
                    disabled={set}
                  >
                    Generate OTP
                  </Button>
                </Col>
                <Col xs={5} sm={5} md={5} lg={5} xl={5}>
                  <FormGroup>
                    <Label className="p-0 m-0">Enter OTP</Label>
                    <Input
                      id="otp"
                      name="otp"
                      type="text"
                      placeholder="Insert OTP"
                      onChange={handleChanged}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseOtpModel} color="secondary">
                Cancel
              </Button>
              {otp.length === 6 ? (
                <Button onClick={handleOnlineOrder} color="primary">
                  Place Order
                </Button>
              ) : (
                <Button color="primary" disabled={true}>
                  Place Order
                </Button>
              )}
            </DialogActions>
          </Dialog>
        </div>
      </div>
    </BuyerContainer>
  );
};

const mapStateToProps = ({ auth, seller, buyer }) => {
  const { userDetails } = seller;
  const { user_details } = auth;
  const { cartDetails, mediWallet, removeFromCart, addToCart } = buyer;
  let users = userDetails ? userDetails : user_details;
  return {
    user_details,
    users,
    cartDetails,
    mediWallet,
    removeFromCart,
    addToCart,
  };
};

export default connect(mapStateToProps, {
  getUserDetail,
  getCartDetails,
  getMediWallet,
  removeFromCart,
  emptyCart,
  addToCart,
})(MyCart);
